<template>
  <el-container>
    <el-container>
      <el-main>
        <div class="Ecard" id="trendChart">
          <div class="testMain">
            <el-form :inline="true" size="mini">
              <el-form-item v-if="localProject == 7" label="增量全量">
                <el-select
                  v-model="type"
                  @change="
                    memoryChange([
                      'is_all',
                      'report_type',
                      'task_id',
                      'device_id',
                      'level',
                      'scene_id',
                    ])
                  "
                >
                  <el-option
                    v-for="(item, k) in typeList"
                    :key="k"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button @click="downloadFile" type="primary">
                  安装包下载
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-popconfirm
                  title="将删除该任务下的选择的机型数据"
                  @confirm="deleteBtn()"
                  placement="top"
                >
                  <template #reference>
                    <el-button type="primary" size="mini">
                      <span>删除</span>
                    </el-button>
                  </template>
                </el-popconfirm>
              </el-form-item>
              <el-form-item>
                <el-button
                  @click="configShow = true"
                  style="height: 25px"
                  type="primary"
                  size="mini"
                >
                  配置基线
                </el-button>
              </el-form-item>
            </el-form>

            <div style="display: flex; justify-content: space-between">
              <el-form :inline="true" size="mini">
                <el-form-item label="测试类型">
                  <el-select
                    filterable
                    @change="
                      memoryChange([
                        'report_type',
                        'task_id',
                        'device_id',
                        'level',
                        'scene_id',
                      ])
                    "
                    v-model="type_query"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, k) in perfTypeOptions"
                      :key="k"
                      :label="item.name"
                      :value="item.report_type"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="日期">
                  <el-select
                    :key="componentKey"
                    v-model="date_name"
                    @change="
                      memoryChange([
                        'task_id',
                        'device_id',
                        'level',
                        'scene_id',
                      ])
                    "
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, k) in perfDateOptions"
                      :key="k"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="设备">
                  <el-select
                    v-model="device_id"
                    @change="memoryChange(['device_id', 'level', 'scene_id'])"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, k) in perfDeviceOptions"
                      :key="k"
                      :label="item.name"
                      :value="item.device_id + ''"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  ><el-button type="primary" @click="memoryBtn"
                    >确定</el-button
                  ></el-form-item
                >
                <el-form-item>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="sendOut"
                    class="down_img"
                    >发送报告<span
                      ><img src="@/assets/down.png" width="12" alt="" /></span
                  ></el-button>
                </el-form-item>
              </el-form>
            </div>

            <div class="config_class">
              <el-dialog width="30%" v-model="configShow">
                <el-form :inline="true" size="mini">
                  <el-form-item label="基线测试">
                    <el-select
                      :key="componentKey"
                      v-model="base_id"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfDateOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="settingsBtn"
                      >确定</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-dialog>
            </div>
            <div class="editRecipient" v-if="edit">
              <el-form
                label-position="left"
                label-width="100px"
                :model="formMail"
                size="mini"
              >
                <el-form-item label="邮件标题">
                  <el-input v-model="formMail.title"></el-input>
                </el-form-item>
                <el-form-item label="邮件发件人">
                  <el-tooltip placement="bottom">
                    <template #content>
                      指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人{{
                        formMail.Sender
                      }}
                    </template>
                    <el-input v-model="formMail.Sender"></el-input>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="邮件收件人">
                  <el-tooltip placement="bottom">
                    <template #content>
                      可按如下任一形式批量添加：
                      <br />1、zhangsan;lisi;wangwu
                      <br />2、zhangsan(张三);lisi(李四);wangwu(王五)
                      <br />3、zhangsan(张三)
                      &lt;zhangsan@tencent.com&gt;;lisi(李四)
                      &lt;lisi@tencent.com&gt;; wangwu(王五)
                      &lt;wangwu@tencent.com&gt;
                    </template>
                    <el-input v-model="formMail.addressee"></el-input>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="邮件抄送人">
                  <el-input v-model="formMail.CC_List"></el-input>
                </el-form-item>
                <el-popconfirm
                  title="确认发送报告吗？"
                  @confirm="save_report(false)"
                  placement="top"
                >
                  <template #reference>
                    <el-button
                      type="primary"
                      :disabled="get_is_super"
                      size="mini"
                    >
                      <el-tooltip
                        effect="dark"
                        content="暂无管理员权限"
                        placement="top"
                        :disabled="!get_is_super"
                      >
                        <span>发送报告</span>
                      </el-tooltip>
                    </el-button>
                  </template>
                </el-popconfirm>
                <el-button size="mini" type="info" class="ms-2" @click="edit = false"
                  >取消</el-button
                >
              </el-form>
            </div>

            <div class="spacName">
              <h5 id="thread_scroll" class="TitleStyle">
                <span></span>内存风险
              </h5>
              <h6
                style="display: flex; align-items: center; margin: 8px 0 8px 0"
              >
                <span class="subTitle">◆</span>
                内存测试(MB)
              </h6>

              <el-table
                v-loading="report_loading"
                border
                size="mini"
                :span-method="mergeCells2"
                :header-cell-style="{
                  background: '#5D99D5',
                  color: '#fff',
                }"
                :data="nativeData"
              >
                <el-table-column align="center" width="100" label="测试场景">
                  <template #default="scope">
                    <span>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="100" label="测试画质">
                  <template #default="scope">
                    <span>{{ scope.row.picture }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" width="100" label="纬度">
                  <template #default="scope">
                    <span>{{ scope.row.data.dimension_str }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  v-for="item in nativeVersionList"
                  :key="item.value"
                  align="center"
                  :label="item.head + ':v.' + item.value + ''"
                >
                  <template v-slot:header>
                    <div>内存值(MB)</div>
                    <div>
                      {{ item.head + ":v." + item.value + "" }}
                    </div>
                  </template>
                  <el-table-column
                    v-for="(v, k) in item.target"
                    :key="k"
                    align="center"
                  >
                    <template v-slot:header>
                      <div>MallocSize</div>
                    </template>
                    <template #default="scope">
                      <span>{{ scope.row.data[item.label][v] }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column
                  v-for="(item, i) in changeList"
                  :key="i"
                  align="center"
                >
                  <template v-slot:header>
                    <div>{{ item.head + "(MB)" }}</div>
                    <div>
                      {{
                        (item.head == "基线变化值" ? "基线版本" : "上一版本") +
                        ":v." +
                        item.value
                      }}
                    </div>
                  </template>
                  <el-table-column
                    v-for="(v, index) in item.target"
                    :key="index"
                    align="center"
                  >
                    <template v-slot:header>
                      <div>MallocSize</div>
                    </template>
                    <template #default="scope">
                      <span
                        :style="'color:' + scope.row.data[item.color[index]]"
                        >{{ risk_color(scope.row.data[v])[0] }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column width="60" align="center" label="风险">
                  <template #default="scope">
                    <span :style="'color:' + risk(scope.row.data.risk)">{{
                      scope.row.data.risk
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="perfReport_top.length > 0">
                <h6
                  style="
                    display: flex;
                    align-items: center;
                    margin: 8px 0 8px 0;
                  "
                >
                  <span class="subTitle">◆</span>
                  内存风险Top增长函数
                </h6>

                <top-table :tableData="perfReport_top" :xcodeReportData="xcodeReportData" />
              </div>
              <div v-if="perfReport_so_top.length > 0">
                <h6
                  style="
                    display: flex;
                    align-items: center;
                    margin: 8px 0 8px 0;
                  "
                >
                  <span class="subTitle">◆</span>
                  内存风险Top增长Library
                </h6>

                <top-table :tableData="perfReport_so_top" :report_loading="report_loading" tableType="so" :xcodeReportData="xcodeReportData" />
              </div>
            </div>

            <div class="spacName">
              <h5 class="TitleStyle"><span></span>内存趋势</h5>
              <h6
                style="display: flex; align-items: center; margin: 8px 0 8px 0"
              >
                <span class="subTitle">◆</span>
                场景趋势
              </h6>
              <div>
                <el-form :inline="true" style="margin-top: 11px" size="mini">
                  <el-form-item label="选择画质">
                    <el-select
                      @change="trendChange"
                      v-model="level_trend"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfLeveOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.level"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="选择场景">
                    <el-select
                      filterable
                      @change="trendChange"
                      v-model="scene_func_id_scene"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfSceneOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.scene_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="时间范围">
                    <el-date-picker
                      v-model="valueTime"
                      type="daterange"
                      range-separator="To"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="timeChange"
                      :default-value="timeDefaultShow"
                    />
                  </el-form-item>
                </el-form>

                <el-card>
                  <div
                    id="native_trend"
                    style="height: 350px; width: 100%"
                  ></div>
                </el-card>
              </div>
              <h6
                style="display: flex; align-items: center; margin: 8px 0 8px 0"
              >
                <span class="subTitle">◆</span>
                Library趋势
              </h6>
              <div>
                <el-form style="margin-top: 11px" :inline="true" size="mini">
                  <el-form-item label="选择画质">
                    <el-select
                      @change="funcChange_api_so"
                      v-model="level_func_so"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfLeveOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.level"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="选择场景">
                    <el-select
                      filterable
                      @change="funcChange_api_so"
                      v-model="scene_func_id_so"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfSceneOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.scene_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="纬度">
                    <el-select
                      v-model="dimension_so"
                      @change="funcChange_api_so"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in dimensionsList"
                        :key="k"
                        :label="item.name"
                        :value="item.type"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="搜索Library">
                    <el-select
                      @change="funcChange_so"
                      v-model="index_func_so"
                      filterable
                      multiple
                      class="input_none"
                      collapse-tags
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in funcSoTrend"
                        :key="k"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <el-card>
                  <div
                    id="so_func_trend"
                    style="height: 350px; width: 100%"
                  ></div>
                </el-card>
              </div>
              <h6
                style="display: flex; align-items: center; margin: 8px 0 8px 0"
              >
                <span class="subTitle">◆</span>
                函数趋势
              </h6>
              <div>
                <el-form style="margin-top: 11px" :inline="true" size="mini">
                  <el-form-item label="选择画质">
                    <el-select
                      @change="funcChange_api"
                      v-model="level_func"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfLeveOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.level"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="选择场景">
                    <el-select
                      filterable
                      @change="funcChange_api"
                      v-model="scene_func_id"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfSceneOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.scene_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="纬度">
                    <el-select
                      v-model="dimension_func"
                      @change="funcChange_api"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in dimensionsList"
                        :key="k"
                        :label="item.name"
                        :value="item.type"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="搜索函数">
                    <el-select
                      @change="funcChange"
                      v-model="index_func"
                      filterable
                      multiple
                      class="input_none"
                      collapse-tags
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in funcTrend.func_list"
                        :key="k"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
                <el-card v-loading="funcLoading">
                  <div
                    id="native_func_trend"
                    style="height: 350px; width: 100%"
                  ></div>
                </el-card>
              </div>
            </div>
            <div class="spacName">
              <h5 id="thread_scroll" class="TitleStyle">
                <span></span>重要内存模块信息
              </h5>
              <el-form :inline="true" size="mini">
                <el-form-item label="选择画质">
                  <el-select
                    @change="importantChange"
                    v-model="level"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, k) in perfLeveOptions"
                      :key="k"
                      :label="item.name"
                      :value="item.level"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="选择场景">
                  <el-select
                    filterable
                    @change="importantChange"
                    v-model="scene_id"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, k) in perfSceneOptions"
                      :key="k"
                      :label="item.name"
                      :value="item.scene_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="纬度">
                  <el-select
                    v-model="dimension_important"
                    @change="importantChange"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, k) in dimensionsList"
                      :key="k"
                      :label="item.name"
                      :value="item.type"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="option_important"
                    @change="importantChange"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, k) in options"
                      :key="k"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <p>注：次数为函数调用次数</p>
              <el-table
                v-loading="moudle_loading"
                border
                :span-method="mergeCells"
                size="mini"
                :header-cell-style="{
                  background: '#5D99D5',
                  color: '#fff',
                }"
                :data="
                  nativeModuleData.slice(
                    (page_native - 1) * size_native,
                    page_native * size_native
                  )
                "
              >
                <el-table-column
                  :show-overflow-tooltip="true"
                  v-if="localProject != 7"
                  label="父模块"
                >
                  <template #default="scope">
                    <span>{{ scope.row.parent }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  :label="localProject == 7 ? '模块' : '子模块'"
                >
                  <template #default="scope">
                    <span>{{ scope.row.sub }}</span>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" label="函数">
                  <template #default="scope">
                    <span>{{ scope.row.func }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Size">
                  <el-table-column align="center" :label="'数值(MB)'">
                    <template #default="scope">
                      <span>{{ scope.row.data.size }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="前后差异(MB)">
                    <template #default="scope">
                      <span
                        :style="
                          'color:' + text(scope.row.data.diff_size_old)[1]
                        "
                        >{{ text(scope.row.data.diff_size_old)[0] }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="基线差异(MB)">
                    <template #default="scope">
                      <span
                        :style="
                          'color:' + text(scope.row.data.diff_size_base)[1]
                        "
                        >{{ text(scope.row.data.diff_size_base)[0] }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column align="center" label="Number">
                  <el-table-column align="center" :label="'数值(次数)'">
                    <template #default="scope">
                      <span>{{ scope.row.data.num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="前后差异(次数)">
                    <template #default="scope">
                      <span
                        :style="'color:' + text(scope.row.data.diff_num_old)[1]"
                        >{{ text(scope.row.data.diff_num_old)[0] }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="基线差异(次数)">
                    <template #default="scope">
                      <span
                        :style="
                          'color:' + text(scope.row.data.diff_num_base)[1]
                        "
                        >{{ text(scope.row.data.diff_num_base)[0] }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
              <el-form
                style="display: flex; align-items: center; margin-top: 19px"
                :inline="true"
                size="mini"
              >
                <el-form-item style="margin-bottom: 0" label="每页">
                  <el-input
                    v-model="size_native"
                    style="width: 55px; height: 28px"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  style="margin-bottom: 0"
                  label="条记录"
                ></el-form-item>

                <el-form-item style="margin-bottom: 0">
                  <el-pagination
                    style="text-align: right"
                    v-model:currentPage="page_native"
                    :page-size="size_native"
                    :total="nativeModuleData.length"
                    layout="total, prev, pager, next,jumper"
                  ></el-pagination>
                </el-form-item>
              </el-form>
            </div>
            <div class="spacName">
              <h5 id="thread_scroll" class="TitleStyle">
                <span></span>全量数据查看
              </h5>
              <div style="display: flex; justify-content: space-between">
                <el-form class="spacForm" size="mini" :inline="true">
                  <el-form-item label="选择画质">
                    <el-select
                      @change="nativeAllChange($event, true)"
                      v-model="level_all"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfLeveOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.level"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="选择场景">
                    <el-select
                      @change="nativeAllChange($event, true)"
                      v-model="scene_natvie_id"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfSceneOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.scene_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="纬度">
                    <el-select
                      v-model="dimension_native"
                      @change="nativeAllChange"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in dimensionsList"
                        :key="k"
                        :label="item.name"
                        :value="item.type"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="对比数据版本">
                    <el-select
                      @change="nativeAllChange"
                      :key="componentKey"
                      v-model="old_date_name"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in allDateOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>

                <div>
                  <el-button size="mini" type="primary" @click="downloadCsv()">
                    导出数据</el-button
                  >
                </div>
              </div>
              <el-form size="mini" :inline="true">
                <el-form-item label="搜索">
                  <el-input
                    v-model="serch_input"
                    @change="onSearch(true)"
                    prefix-icon="el-icon-search"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Top">
                  <el-select
                    @change="onSearch(true)"
                    v-model="top"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in sizeOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div class="native_table">
                <el-table
                  v-loading="nativeTableAllLoading"
                  id="detailTable"
                  border
                  size="mini"
                  :header-cell-style="{
                    background: '#5D99D5',
                    color: '#fff',
                  }"
                  :key="newCount"
                  @sort-change="sort_change"
                  :data="nativeTableAll"
                >
                  <el-table-column
                    align="left"
                    sortable="custom"
                    :show-overflow-tooltip="true"
                    label="functionName"
                    width="200"
                    prop="functionName"
                  />
                  <el-table-column
                    width="120"
                    align="left"
                    sortable="custom"
                    :show-overflow-tooltip="true"
                    label="LibraryName"
                    prop="soName"
                  />
                  <el-table-column
                    align="center"
                    v-for="(item, k) in nativeAllHead"
                    :label="
                      item.label +
                      (item.new.indexOf('Number') != -1 ? '' : '(MB)')
                    "
                    :key="k"
                  >
                    <el-table-column
                      align="center"
                      sortable="custom"
                      :prop="item.new"
                      label="数值"
                    >
                      <template #default="scope">
                        {{ scope.row[item.new] }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      sortable="custom"
                      :prop="item.old"
                      label="差异"
                    >
                      <template #default="scope">
                        {{ risk_color(scope.row[item.old])[0] }}
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </div>

              <el-form
                style="display: flex; align-items: center; margin-top: 19px"
                :inline="true"
                size="mini"
              >
                <el-form-item style="margin-bottom: 0" label="每页">
                  <el-input
                    v-model="size"
                    style="width: 55px; height: 28px"
                    @change="onSearch(false)"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  style="margin-bottom: 0"
                  label="条记录"
                ></el-form-item>

                <el-form-item style="margin-bottom: 0">
                  <el-pagination
                    style="text-align: right"
                    v-model:currentPage="page"
                    :page-size="size"
                    :total="nativeAllData.length"
                    layout="total, prev, pager, next,jumper"
                    @current-change="onSearch(false)"
                  ></el-pagination>
                </el-form-item>
              </el-form>
            </div>
            <div class="spacName">
              <h5 id="thread_scroll" class="TitleStyle">
                <span></span>Library数据查看
              </h5>
              <div style="display: flex; justify-content: space-between">
                <el-form class="spacForm" size="mini" :inline="true">
                  <el-form-item label="选择画质">
                    <el-select
                      @change="nativeAllChangeSo($event, true)"
                      v-model="level_so"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfLeveOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.level"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="选择场景">
                    <el-select
                      @change="nativeAllChangeSo($event, true)"
                      v-model="scene_so_id"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in perfSceneOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.scene_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="纬度">
                    <el-select
                      v-model="dimension_so_all"
                      @change="nativeAllChangeSo"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in dimensionsList"
                        :key="k"
                        :label="item.name"
                        :value="item.type"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="对比数据版本">
                    <el-select
                      @change="nativeAllChangeSo"
                      :key="componentKey"
                      v-model="old_date_so_name"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, k) in libDateOptions"
                        :key="k"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <el-form size="mini" :inline="true">
                <el-form-item label="搜索">
                  <el-input
                    v-model="serch_input_so"
                    @change="onSearchSo(true)"
                    prefix-icon="el-icon-search"
                    size="mini"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Top">
                  <el-select
                    @change="onSearchSo(true)"
                    v-model="top_so"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in sizeOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div class="native_table">
                <el-table
                  v-loading="nativeTableAllLoading"
                  id="detailTable"
                  border
                  size="mini"
                  :header-cell-style="{
                    background: '#5D99D5',
                    color: '#fff',
                  }"
                  @sort-change="sort_change_so"
                  :data="nativeTableSoAll"
                >
                  <el-table-column
                    width="300"
                    sortable="custom"
                    :show-overflow-tooltip="true"
                    label="LibraryName"
                    prop="soName"
                  />
                  <el-table-column
                    align="center"
                    v-for="(item, k) in nativeAllHead1"
                    :label="
                      item.label +
                      (item.new.indexOf('Number') != -1 ? '' : '(MB)')
                    "
                    :key="k"
                  >
                    <el-table-column
                      align="center"
                      sortable="custom"
                      :prop="item.new"
                      label="数值"
                    >
                      <template #default="scope">
                        {{ scope.row[item.new] }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      sortable="custom"
                      :prop="item.old"
                      label="差异"
                    >
                      <template #default="scope">
                        {{ risk_color(scope.row[item.old])[0] }}
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </div>

              <el-form
                style="display: flex; align-items: center; margin-top: 19px"
                :inline="true"
                size="mini"
              >
                <el-form-item style="margin-bottom: 0" label="每页">
                  <el-input
                    v-model="size_so"
                    style="width: 55px; height: 28px"
                    @change="onSearchSo(false)"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  style="margin-bottom: 0"
                  label="条记录"
                ></el-form-item>

                <el-form-item style="margin-bottom: 0">
                  <el-pagination
                    style="text-align: right"
                    v-model:currentPage="page_so"
                    :page-size="size_so"
                    :total="nativeAllSoData.length"
                    layout="total, prev, pager, next,jumper"
                    @current-change="onSearchSo(false)"
                  ></el-pagination>
                </el-form-item>
              </el-form>
            </div>
            
            <h5 id="thread_scroll" class="TitleStyle">
              <span></span>内存火焰图
            </h5>
            <el-form class="spacForm" size="mini" :inline="true">
              <el-form-item label="选择画质">
                <el-select
                  @change="flameAllChangeSo"
                  v-model="flame_so"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, k) in perfLeveOptions"
                    :key="k"
                    :label="item.name"
                    :value="item.level"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择场景">
                <el-select
                  @change="flameAllChangeSo"
                  v-model="scene_flame_id"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, k) in perfSceneOptions"
                    :key="k"
                    :label="item.name"
                    :value="item.scene_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="纬度">
                <el-select
                  v-model="dimension_memory"
                  @change="flameAllChangeSo"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, k) in dimensionsList"
                    :key="k"
                    :label="item.name"
                    :value="item.type"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select
                  v-model="option_memory"
                  @change="flameAllChangeSo"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, k) in options"
                    :key="k"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-form class="spacForm" size="mini" :inline="true">
              <el-form-item label="size">
                <el-input
                  placeholder="单位KB"
                  v-model="flame_size_input"
                ></el-input>
              </el-form-item>
              <el-form-item label="so">
                <!-- <el-input v-model="flame_so_input"></el-input> -->
                <el-select
                  v-model="flame_so_input"
                  multiple
                  filterable
                  collapse-tags
                  collapse-tags-tooltip
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, k) in funcSoTrend"
                    :key="k"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="function">
                <el-input v-model="flame_function_input"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="flame_btn" type="primary">确定</el-button>
              </el-form-item>
              <el-form-item>
                <el-button @click="check_view_memory" type="primary">{{
                  changeViewMemory ? "相对视图" : "原始视图"
                }}</el-button>
              </el-form-item>
              <!-- <el-form-item>
                <el-button @click="screen('memory_xcode')" type="primary"
                  >全屏显示</el-button
                >
              </el-form-item> -->
            </el-form>
            
            <div
              v-if="flameShow"
              v-loading="flameLoading"
              style="mini-height: 400px"
            >
              <div id="chart" class="chart-area"></div>
            </div>
            <div v-else>
              <el-empty description="无堆栈数据"></el-empty>
            </div>
            
            <div class="my-5">
              <h5 id="thread_scroll" class="TitleStyle">
                <span></span>内存堆栈对比
              </h5>
              <el-form class="spacForm" size="mini" :inline="true">
                <el-form-item label="选择画质">
                  <el-select v-model="level_stack" placeholder="请选择">
                    <el-option
                      v-for="(item, k) in perfLeveOptions"
                      :key="k"
                      :label="item.name"
                      :value="item.level"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="选择场景">
                  <el-select v-model="scene_stack_id" placeholder="请选择">
                    <el-option
                      v-for="(item, k) in perfSceneOptions"
                      :key="k"
                      :label="item.name"
                      :value="item.scene_id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="对比数据版本">
                  <el-select v-model="old_stack_name" placeholder="请选择">
                    <el-option
                      v-for="(item, k) in perfDateOptions"
                      :key="k"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <el-form class="spacForm" size="mini" :inline="true">
                <el-form-item label="size">
                  <el-input
                    placeholder="单位KB"
                    v-model="flame_size_stack_input"
                  ></el-input>
                </el-form-item>
                <el-form-item label="so">
                  <!-- <el-input v-model="flame_so_input"></el-input> -->
                  <el-select
                    v-model="flame_stack_so_input"
                    multiple
                    filterable
                    collapse-tags
                    collapse-tags-tooltip
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, k) in funcSoTrend"
                      :key="k"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="function">
                  <el-input v-model="flame_stack_function_input"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="flame_btn_stack" type="primary"
                    >确定</el-button
                  >
                </el-form-item>

                <!-- <el-form-item>
                  <el-button @click="screen('ios-merge')" type="primary"
                    >全屏显示</el-button
                  >
                </el-form-item> -->
              </el-form>

              <div v-loading="flameLoadingStack">
                <div style="display: flex">
                  <p class="frames-info">
                    增加堆栈数:<span class="frames-num">{{
                      perfettoStack_v2.increase.Count
                    }}</span
                    >个,
                  </p>
                  <p class="frames-info">
                    相同堆栈数:<span class="frames-num">{{
                      perfettoStack_v2.tree.Count
                    }}</span
                    >个,
                  </p>
                  <p class="frames-info">
                    减少堆栈数:<span class="frames-num">{{
                      perfettoStack_v2.decrease.Count
                    }}</span
                    >个
                  </p>
                </div>
                <div v-if="merge_show" id="merge" class="chart-area"></div>
                <div v-loading="flameLoadingStack" v-else>
                  <el-empty description="无堆栈数据"></el-empty>
                </div>

                <el-form label-width="auto">
                  <el-form-item label="堆栈类型">
                    <el-select v-model="stackType" size="mini" placeholder="">
                      <el-option label="相同堆栈" value="tree" />
                      <el-option label="新增堆栈" value="increase" />
                      <el-option label="减少堆栈" value="decrease" />
                    </el-select>
                  </el-form-item>
                </el-form>
                <el-table :data="stackTableData" row-key="rowKey" :key="stackTableKey" @sort-change="onSortChange">
                  <el-table-column prop="Name" label="Overview" width="800" />
                  <el-table-column label="当前版本" #default="{row}" :sortable="stackType == 'decrease' ? false : 'custom'">
                    {{ getCurVersion(row) }}
                  </el-table-column>
                  <el-table-column label="变化值" #default="{row}" :sortable="stackType == 'increase' ? false : 'custom'">
                    {{ getDiffVersion(row) }}
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <div class="spacName">
              <h5 id="thread_scroll" class="TitleStyle">
                <span></span>源数据下载
              </h5>
              <el-table
                v-loading="report_loading"
                border
                size="mini"
                :header-cell-style="{
                  background: '#5D99D5',
                  color: '#fff',
                }"
                :data="perfReport_file_list"
              >
                <!-- <el-table-column
                  align="center"
                  label="上传时间"
                  prop="测试时间"
                ></el-table-column> -->
                <el-table-column
                  align="center"
                  label="机型"
                  prop="机型"
                ></el-table-column>
                <el-table-column
                  align="center"
                  label="测试画质"
                  prop="测试画质"
                ></el-table-column>
                <el-table-column
                  align="center"
                  label="测试场景"
                  prop="测试场景"
                ></el-table-column>
                <el-table-column
                  align="center"
                  label="数据类型"
                  prop="维度"
                ></el-table-column>
                <!-- <el-table-column align="center" label="TotalNative内存火焰图">
                  <template #default="scope">
                    <a
                      style="
                        color: #61c3e4;
                        text-decoration: underline;
                        cursor: pointer;
                      "
                      @click="
                        btnAll(scope.row['测试场景'], scope.row['测试画质'])
                      "
                      >点击查看
                    </a></template
                  ></el-table-column
                > -->

                <!-- <el-table-column
                  align="center"
                  label="内存火焰图"
                >
                  <template #default="scope">
                    <a
                      style="
                        color: #61c3e4;
                        text-decoration: underline;
                        cursor: pointer;
                      "
                      @click="btn(scope.row['测试场景'], scope.row['测试画质'])"
                      >点击查看火焰图
                    </a></template
                  ></el-table-column
                > -->
                <el-table-column align="center" label="火焰图下载">
                  <template #default="scope">
                    <a download :href="scope.row['火焰图下载链接']">下载链接</a>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="源数据下载">
                  <template #default="scope">
                    <a download :href="scope.row['源数据下载链接']">数据下载</a>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <div style="display: flex; align-items: center">
                <h5 id="thread_scroll" class="TitleStyle">
                  <span></span>测试说明
                </h5>
                <!-- <span
                    style="margin-left: 20px; color: #409eff; cursor: pointer"
                    @click="edit_text()"
                    >{{ edit_show ? "提交" : "编辑" }}</span
                  > -->
              </div>
              <a target="_blank" :href="down_url" class="link-like"
                >安装包蓝盾流水线链接</a
              >
              <el-table
                border
                size="mini"
                :header-cell-style="{
                  background: '#5D99D5',
                  color: '#fff',
                }"
                :data="perfReport_overview"
              >
                <el-table-column label="测试场景">
                  <template #default="scope">
                    <span>{{ scope.row.scene }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="测试场景说明">
                  <template #default="scope">
                    <p v-if="!edit_show" v-html="scope.row.text"></p>
                    <!-- <QuillEditor
                              v-if="edit_show"
                          v-model:content="scope.row.text"
                          contentType="html"
                          :options="editorOption"
                          theme="snow"
                        /> -->
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div class="footer">
            <img src="@/assets/performance/footer.png" alt />
          </div>
        </div>
        <div v-if="backShow" class="backdrop"></div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
//css代码与gametool完全一样，js代码仅下面两行不一样，html有细微差异。修改后注意代码同步
import { ElMessage } from "element-plus";
// import { Message as ElMessage } from "element-ui";
import * as echarts from "echarts";
import { flamegraph } from "d3-flame-graph";
import * as d3 from "d3";
import TopTable from './top-table.vue'
import {
  dateConversion,
  grAxios,
  getLocalProject,
} from "@/utils";

const store = {}
const useApis = {
  data() {
    return {
      perfDateOptions: [],
      settings: {},
      perfDeviceOptions: [],
      dimensionsList: [],
      nativeModuleData: [],
      perfettoStack: {},
      soTrend: {},
      nativeAllSoData: [],
      nativeAllData: [],
      old_version: '',
      funcTrend: {},
      perfTypeOptions: [],
      nativeTrendData: {},
      perfLeveOptions: [],
      perfSceneOptions: [],
      down_url: '',
      xcodeReportData: {},
    }
  },

  computed: {
    scene_flame_list() {
      let list = [];
      list = Object.keys(this?.xcodeReportData?.func_list || {});
      return list;
    },
    scene_flame_so_list() {
      let list = [];
      list = Object.keys(this?.xcodeReportData?.so_list || {});
      return list;
    },
    level_flame_list() {
      let list = [];
      if (this.scene_flame) {
        list = Object.keys(this?.xcodeReportData?.func_list?.[this.scene_flame]);
      }

      return list;
    },
    level_flame_so_list() {
      let list = [];
      if (this.so_scene_flame) {
        list = Object.keys(
          this?.xcodeReportData?.so_list?.[this.so_scene_flame]
        );
      }

      return list;
    },
    so_list() {
      let list = [];
      if (this.so_level_flame) {
        list = this?.xcodeReportData?.so_list?.[this.so_scene_flame][
          this?.so_level_flame
        ];
      }

      return list;
    },
    sizeOptions() {
      let list = [10, 20, 30, "all"];

      return list;
    },

    perfReport() {
      return this.xcodeReportData.native;
    },
    perfReportPkg() {
      return this.xcodeReportData.pipeline_download_url;
    },
    perfReport_overview() {
      let list = [
        { scene: "LaunchGame", text: "游戏启动到大厅的部分" },
        { scene: "LobbyRooms", text: "游戏大厅、游戏房间，进入加载阶段" },
        { scene: "InGamePlay", text: "游戏对局内/休闲区场景内" },
      ];

      if (this.localProject === 34) {
        list = [
          { scene: "10Person", text: "从启动游戏到10真人战斗18分钟结束采集" },
          // {
          //   scene: "SelectHero",
          //   text: "从开始启动游戏到刚开始进入Battle战斗场景之前",
          // },
          // { scene: "Battle5v5", text: "从开始启动游戏到结束战斗前5s" },
          // {
          //   scene: "LobbyWait",
          //   text: "从开始启动游戏到结束战斗后再返回大厅静置5min",
          // },
        ];
      } else if (this.localProject === 4) {
        list = [
          { scene: "Loading", text: "从开始启动游戏到进入大厅静置10s稳定下来" },
        ]
      } else {
        list = [
          { scene: "Loading", text: "从开始启动游戏到进入大厅静置10s稳定下来" },
          {
            scene: "SelectHero",
            text: "从开始启动游戏到刚开始进入Battle战斗场景之前",
          },
          { scene: "Battle5v5", text: "从开始启动游戏到结束战斗前5s" },
          {
            scene: "LobbyWait",
            text: "从开始启动游戏到结束战斗后再返回大厅静置5min",
          },
        ];
      }
      return list;
    },
    perfReport_file_list() {
      return this.xcodeReportData.file_list;
    },
    perfReport_top() {
      let data = this.xcodeReportData.top_table;
      let list = [];
      data?.forEach((v) => {
        v.functions.forEach((m) => {
          list.push({
            level: v.level,
            scene: v.scene_name,
            id: v.id,
            old_id: v.old_id,
            dimension: v.dimension_str,
            dimensions: v.dimension,
            curVersion: v.cur_version,
            lastVersion: v.last_version,
            diif_new: v.cur,
            memory_diff: v.diff,
            funcName: m.func_name,
            diff: m.diff,
            type: v.type,
          });
        });
      });
      const sortedData = list.sort((a, b) => {
        if (a.level < b.level) {
          return -1;
        } else if (a.level > b.level) {
          return 1;
        } else {
          return 0;
        }
      });

      return sortedData;
    },
    perfReport_so_top() {
      let data = this.xcodeReportData.top_so_table;
      let list = [];
      data?.forEach((v) => {
        v.functions.forEach((m) => {
          list.push({
            level: v.level,
            scene: v.scene_name,
            id: v.id,
            dimension: v.dimension_str,
            dimensions: v.dimension,
            old_id: v.old_id,
            curVersion: v.cur_version,
            lastVersion: v.last_version,
            diif_new: v.cur,
            memory_diff: v.diff,
            funcName: m.func_name,
            diff: m.diff,
            type: v.type,
          });
        });
      });
      const sortedData = list.sort((a, b) => {
        if (a.level < b.level) {
          return -1;
        } else if (a.level > b.level) {
          return 1;
        } else {
          return 0;
        }
      });

      return sortedData;
    },
    
    nativeData() {
      let list = [];
      for (let i in this.perfReport) {
        for (let k in this.perfReport[i]) {
          for (let t in this.perfReport[i][k]) {
            list.push({
              name: i,
              picture: k,
              latitude: t,
              data: this.perfReport[i][k][t],
            });
          }
        }
      }

      return list;
    },
  },

  methods: {
    async dispatchXcodeReport(store, params) {
      const res = await grAxios({
        url: `/xcode/perfetto_report/`,
        params,
      })
      this.xcodeReportData = res.data
      this.down_url = res.data.pipeline_download_url
    },

    async dispatchXcodeSceneOptions(store, params) {
      const res = await grAxios({
        url: `/xcode/scene_option/`,
        params,
      })
      this.perfSceneOptions = res.data.options
    },

    async dispatchXcodeLevelOptions(store, params) {
      const res = await grAxios({
        url: `/xcode/level_option/`,
        params,
      })
      this.perfLeveOptions = res.data.options
    },

    async dispatchXcodeNativeTrend(store, params) {
      const res = await grAxios({
        url: `/xcode/native_trend/`,
        params,
      })
      this.nativeTrendData = res.data
    },

    async dispatchUploadXcodeReport(store, data) {
      const res = await grAxios({
        method: 'post',
        url: `/xcode/perfetto_report/`,
        data,
      })
      return res.data
    },

    async dispatchPerfettoSettingsEdit(store, data) {
      const res = await grAxios({
        method: 'put',
        url: `/proj/project_setting/`,
        data,
      })
      return res.data
    },

    async dispatchXcodeTypeOptions(store, params) {
      const res = await grAxios({
        url: `/xcode/type_option/`,
        params,
      })
      this.perfTypeOptions = res.data.options
    },

    async dispatchXcodeNativeFuncTrend(store, params) {
      const res = await grAxios({
        url: `/xcode/func_trend/`,
        params,
      })
      this.funcTrend = res.data
    },

    async dispatchDeleteXcode(store, params) {
      const res = await grAxios({
        method: 'delete',
        url: `/xcode/xcode_upload/`,
        params,
      })
      return res.data
    },

    async dispatchXcodeNativeAll(store, params) {
      const res = await grAxios({
        url: `/xcode/native_all/`,
        params,
      })
      this.nativeAllData = res.data.list
      this.old_version = res.data.old_version
    },

    async dispatchXcodeNativeAllExport(store, params) {
      const res = await grAxios({
        url: `/xcode/native_export/`,
        params,
        responseType: 'blob',
      })
      return res.data
    },

    async dispatchXcodeSoAll(store, params) {
      const res = await grAxios({
        url: `/xcode/so_all/`,
        params,
      })
      this.nativeAllSoData = res.data.list
    },

    async dispatchXcodeSoList(store, params) {
      const res = await grAxios({
        url: `/xcode/so_list/`,
        params,
      })
      return res.data
    },
    async dispatchXcodeSoFuncTrend(store, data) {
      const res = await grAxios({
        method: 'post',
        url: `/xcode/so_trend/`,
        data,
      })
      this.soTrend = res.data
    },
    async dispatchXcodeStack(store, params) {
      const {data} = await grAxios({
        url: `/xcode/xcode_stack/`,
        params,
      })
      
      let obj = JSON.parse(JSON.stringify(data));
      if (
        data?.children?.length == 0 ||
        JSON.stringify(obj) === "{}"
      ) {
        obj = {};
      } else {
        if (!this.changeViewMemory) {
          this.traverse_update_node(obj);

          this.addXcodeValueField(obj);
        } else {
          this.addXcodeValueField(obj);
        }
      }

      this.perfettoStack = obj
    },
    async dispatchXcodeDateOptions(store, params) {
      const {data} = await grAxios({
        url: `/xcode/date_option/`,
        params,
      })
      this.perfDateOptions = data.date_list
    },
    async dispatchPerfettoSettings(store, params) {
      const {data} = await grAxios({
        url: `/proj/project_setting/`,
        params,
      })
      this.settings = JSON.parse(data.settings)
    },
    async dispatchXcodeDeviceOptions(store, params) {
      const {data} = await grAxios({
        url: `/xcode/device_option/`,
        params,
      })
      this.perfDeviceOptions = data.device_list
    },
    async dispatchXcodeDimensOptions(store, params) {
      const {data} = await grAxios({
        url: `/xcode/dimensions/`,
        params,
      })
      this.dimensionsList = data
    },
    async dispatchXcodeNativeModule(store, params) {
      let {data} = await grAxios({
        url: `/xcode/native_module/`,
        params,
      })

      data = data.module;
      let list = [];
      for (let i in data) {
        for (let k in data[i].sub_module) {
          for (let c in data[i].sub_module[k].functions) {
            list.push({
              parent: i,
              sub: k,
              func: c,
              data: data[i].sub_module[k].functions[c],
            });
          }
        }
      }

      this.nativeModuleData = list
    },
    dispatchXcodeFileName(store, params) {
      return grAxios({
        url: `/xcode/filename/`,
        params,
      })
    },
    dispatchPerfettoDownLoadDimensionStack(store, params) {
      return grAxios({
        url: `/xcode/stack_download/`,
        params,
        responseType: 'blob',
      })
    },
    dispatchPerfettoDownLoadStack(store, params) {
      return grAxios({
        url: `/perfetto/perfetto_stack_download/`,
        params,
        responseType: 'blob',
      })
    },
  }
}

/* 内存堆栈对比表格 */
const useStackTable = {
  data() {
    return {
      stackType: 'tree',
      allStackData: {},
      stackTableKey: Math.random(),
    }
  },

  computed: {
    stackTableData() {
      const data = this.allStackData?.[this.stackType] || {}
      this.handleStackData(data)
      return data ? [data] : []
    }
  },

  methods: {
    handleStackData(obj) {
      if (obj) obj.rowKey = Math.random()
      obj.children?.forEach(item => this.handleStackData(item))
    },
    async onSortChange({column, order}) {
      let sort_key = ''
      if (column?.label == '当前版本') {
        sort_key = 'MallocSize'
      } else if (column?.label == '变化值') {
        sort_key = this.stackType == 'tree' ? 'MallocSizeDiff' : 'MallocSize'
      }

      const {data} = await grAxios({
        url: 'xcode/xcode_stack_v2/',
        params: {
          project: this.localProject,
          level: this.level_stack,
          date: this.date,
          version: this.version,
          device_id: this.device_id,
          report_type: this.type_query,
          scene_name: this.scene_stack_id,
          size: this.flame_size_stack_input,
          so: this.flame_stack_so_input.join(";"),
          func: this.flame_stack_function_input,
          old_date: this.old_date_stack,
          old_version: this.old_version_stack,
          type: this.type,
          dimension: this.dimension_memory,
          option: this.option_memory,
          sort_key,
          reverse: order == 'ascending' ? 0 : 1,
        }
      })

      this.allStackData = data
    },
    getStackRowKey(row) {
      return 'rowKey'
      //return `${row.id}-${row.count}`
    },
    handleSize(val) {
      if (!val) return 0
      else if (val < 1024) {
        return val + 'B'
      } else if (val < 1024 * 1024) {
        return (val / 1024).toFixed(2) + 'KB'
      } else {
        return (val / 1024 / 1024).toFixed(2) + 'MB'
      }
    },
    getCurVersion(row) {
      if (/^tree|increase$/.test(this.stackType)) {
        return this.handleSize(row.MallocSize)
      } else {
        return '--'
      }
    },
    getDiffVersion(row) {
      if (this.stackType == 'tree') {
        return this.handleSize(row.MallocSizeDiff)
      } else if (this.stackType == 'decrease') {
        return this.handleSize(row.MallocSize)
      } else {
        return '--'
      }
    },
  }
}

/* 内存堆栈对比 */
const useStack = {
  data() {
    return {
      stack_show: false,
    }
  },

  computed: {
    perfettoStack_v2() {
      let obj = JSON.parse(JSON.stringify(this.stackV2Data));
      if (
        this.stackV2Data?.tree?.children?.length == 0 ||
        JSON.stringify(obj.tree) === "{}"
      ) {
        console.log("-");
      } else {
        this.addValueField2(obj?.tree);
      }
      if (
        this.stackV2Data?.increase?.children?.length == 0 ||
        JSON.stringify(obj.increase) === "{}"
      ) {
        console.log("-");
      } else {
        this.addValueField2(obj?.increase);
      }
      if (
        this.stackV2Data?.decrease?.children?.length == 0 ||
        JSON.stringify(obj.decrease) === "{}"
      ) {
        console.log("-");
      } else {
        this.addValueField2(obj?.decrease);
      }

      return obj;
    }
  },

  methods: {
    renderStackV2() {
      const chart = flamegraph().width(1200).inverted(true)
      const data = {
        "name": "root",
        "value": 100,
        "children": [
          {
            "name": "root",
            "value": 30,
            "children": [
              {
                "name": "subFunctionA1",
                "value": 10
              },
              {
                "name": "subFunctionA2",
                "value": 20
              }
            ]
          },
          {
            "name": "root",
            //"value": 70
          },
          {
            "name": "root",
            //"value": 70
          },
        ]
      }

      d3.select("#merge")
        .datum(data)
        .call(chart)
    },

    addValueField2(data) {
      if (data) {
        if (data?.Name == "root") {
          data.rowKey = `${Math.random()}`
          data.name = data?.Name +
            " " +
            (data?.MallocSize / 1024 / 1024).toFixed(2) +
            "MB";
          data.value = data?.MallocSize
        } else {
          data.rowKey = `${Math.random()}`
          data.name = data.Name
          data.value = data.MallocSize
        }

        if (Array.isArray(data.children)) {
          data.children.forEach((child) => {
            this.addValueField2(child);
          });
        }
      }
    },

    labelTime2(d, data) {
      return (
        d.data.name +
        "\nLibraryName: " +
        d.data.LibraryName +
        "\nMallocSize: " +
        this.getNum(d.data.value) +
        (d.data.MallocSizeDiff ? this.diffNum(d.data.MallocSizeDiff) : "") +
        "\nCount: " + d.data.Count
      );
    },

    labelWallTime_v2(d, originalColor, colorMapper) {
      // 使用 colorMapper 计算颜色
      const color = colorMapper(d.data.value);

      // 如果没有输入，直接返回计算出的颜色
      if (
        this.flame_stack_function_input === "" &&
        this.flame_stack_so_input.length == 0
      ) {
        return color;
      } else {
        // 如果输入存在，根据输入内容判断是否需要修改颜色
        if (this.flame_stack_function_input) {
          let list = [this.flame_stack_function_input];
          // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
          const hasMatchingKeyword = list.some((v) => {
            return (
              d.data.Name.toUpperCase().indexOf(v.toUpperCase()) !== -1
            );
          });

          // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
          return hasMatchingKeyword ? "#f00" : color;
        }
        if (this.flame_stack_so_input.length > 0) {
          const hasMatchingKeyword = this.flame_stack_so_input.some((v) => {
            return d.data.LibraryName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
          });

          // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色

          return hasMatchingKeyword ? "#f00" : color;
        }
      }
    },

    renderFlame_v2_merge(selector, data) {
      let flame = flamegraph();
      function getAllValues(node) {
        const values = [node.value];
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => {
            values.push(...getAllValues(child));
          });
        }
        return values;
      }
      let color_list = [];

      color_list = ["#B6EBCF  ", "#FEBEBE", "#DAC4FF"];

      // 获取火焰图数据中的最大值
      const treeRootValue = this.perfettoStack_v2?.tree.MallocSize;
      const decreaseRootValue = this.perfettoStack_v2?.decrease.MallocSize;
      const increaseRootValue = this.perfettoStack_v2?.increase.MallocSize;
      const treeColorMapper = d3
        .scaleLinear()
        .domain([0, treeRootValue * 0.5, treeRootValue])
        .range(["#B6EBCF", "#FEBEBE", "#DAC4FF"]);

      const decreaseColorMapper = d3
        .scaleLinear()
        .domain([0, decreaseRootValue * 0.5, decreaseRootValue])
        .range(["#6EC3FF", "#FFD15C", "#FF6A5C"]);

      const increaseColorMapper = d3
        .scaleLinear()
        .domain([0, increaseRootValue * 0.5, increaseRootValue])
        .range(["#6EC3FF", "#FFD15C", "#4CAF50"]);

      flame
        .width(1200)
        .label((d) => this.labelTime2(d, data))
        .transitionDuration(1000)
        .setColorMapper((d, originalColor) => {
          let colorMapper;
          if (d.data.type === "public") {
            colorMapper = treeColorMapper;
          } else if (d.data.type === "decrease") {
            colorMapper = decreaseColorMapper;
          } else if (d.data.type === "increase") {
            colorMapper = increaseColorMapper;
          } else if (d.data.type === "merge") {
            colorMapper = () => "gray";
          } else {
            colorMapper = () => 'rgb(208, 235, 215)';
          }

          return this.labelWallTime_v2(d, originalColor, colorMapper);
        })
        .inverted(true);

      d3.select(selector).datum(data).call(flame)
    },

    renderFlame_v2(selector, data) {
      let flame = flamegraph();
      function getAllValues(node) {
        const values = [node.value];
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => {
            values.push(...getAllValues(child));
          });
        }
        return values;
      }
      let color_list = [];
      if (selector == "#tree") {
        color_list = ["#B6EBCF  ", "#FEBEBE", "#DAC4FF"];
      } else if (selector == "#decrease") {
        color_list = ["#6EC3FF", "#FFD15C", "#FF6A5C"];
      } else if (selector == "#increase") {
        color_list = ["#6EC3FF", "#FFD15C", "#4CAF50"];
      }
      // 获取火焰图数据中的最大值
      const allValues = getAllValues(data);
      function getMaxValueByType(data, type) {
        return d3.max(getAllValues(data).filter((d) => d.type === type));
      }
      const maxTreeValue = getMaxValueByType(data, "public");
      const maxDecreaseValue = getMaxValueByType(data, "decrease");
      const maxIncreaseValue = getMaxValueByType(data, "increase");
      const decreaseColorMapper = d3
        .scaleLinear()
        .domain([0, maxDecreaseValue * 0.5, maxDecreaseValue])
        .range(["#6EC3FF", "#FFD15C", "#FF6A5C"]);

      const increaseColorMapper = d3
        .scaleLinear()
        .domain([0, maxIncreaseValue * 0.5, maxIncreaseValue])
        .range(["#6EC3FF", "#FFD15C", "#4CAF50"]);
      const treeColorMapper = d3
        .scaleLinear()
        .domain([0, maxTreeValue * 0.5, maxTreeValue])
        .range(["#B6EBCF", "#FEBEBE", "#DAC4FF"]);
      const maxDataValue = d3.max(allValues);

      // 创建颜色映射器
      const colorMapper = d3
        .scaleLinear()
        .domain([0, maxDataValue * 0.5, maxDataValue])
        .range(color_list);
      flame
        .width(400)
        .label((d) => this.labelTime(d, data))
        // .tooltip({ show: this.customTooltip })
        .transitionDuration(1000)
        // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
        .setColorMapper((d, originalColor) => {
          let color;
          if (d.data.type === "public") {
            color = treeColorMapper(d.data.value);
          } else if (d.data.type === "decrease") {
            color = decreaseColorMapper(d.data.value);
          } else if (d.data.type === "increase") {
            color = increaseColorMapper(d.data.value);
          }
          return this.labelWallTime_v2(d, originalColor, color);
        })
        .inverted(true);
      // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

      // .inverted(true);

      // flame.onHover((node) => {
      //   this.func_name = node.data.name;
      //   this.func_rate = node.data.rate + "%";
      // });

      d3.select(selector).datum(data).call(flame);
      // d3.select(selector).style("background-color", "#333");
    },

    async stack_v2_api() {
      this.old_date_stack = this.perfDateOptions.filter(
        (v) => v.name == this.old_stack_name
      )[0].date;
      this.old_version_stack = this.perfDateOptions.filter(
        (v) => v.name == this.old_stack_name
      )[0].version;

      const params = {
        project: this.localProject,
        level: this.level_stack,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.type_query,
        scene_name: this.scene_stack_id,
        size: this.flame_size_stack_input,
        so: this.flame_stack_so_input.join(";"),
        func: this.flame_stack_function_input,
        old_date: this.old_date_stack,
        old_version: this.old_version_stack,
        type: this.type,
        dimension: this.dimension_memory,
        option: this.option_memory,
      }

      const {data} = await grAxios({url: 'xcode/xcode_stack_v2/', params})
      this.stackV2Data = data

      let merge_stack = {
        children: [
          this.perfettoStack_v2?.increase,
          this.perfettoStack_v2?.tree,
          this.perfettoStack_v2?.decrease,
        ],
        Name: "root",
        MallocSize: this.perfettoStack_v2?.increase.MallocSize + this.perfettoStack_v2?.decrease.MallocSize + this.perfettoStack_v2.tree.MallocSize,
        type: "merge",
      };
      this.addValueField2(merge_stack);

      if (
        JSON.stringify(this.perfettoStack_v2?.increase) == "{}" &&
        JSON.stringify(this.perfettoStack_v2?.decrease) === "{}" &&
        JSON.stringify(this.perfettoStack_v2?.tree) === "{}"
      ) {
        this.merge_show = false;
      } else {
        this.merge_show = true;
      }
      this.$nextTick(() => {
        if (this.merge_show) {
          this.renderFlame_v2_merge("#merge", merge_stack);
        }
      });
      this.flameLoadingStack = false;
    },
  }
}

export default {
  mixins: [useStackTable, useStack, useApis],

  components: {
    TopTable,
  },

  data() {
    return {
      get_is_super: false,
      allDateOptions: [],
      libDateOptions: [],
      timeDefaultShow: null,
      flameShow: true,
      backShow: false,
      page: 1,
      page_so: 1,
      size: 10,
      size_so: 10,
      flameLoading: false,
      flameLoadingStack: false,
      flame_check_data: true,

      scene_flame: "",
      level_flame: "",
      functions_flame: "",
      so_scene_flame: "",
      so_level_flame: "",
      so_flame: [],
      scene_natvie_id: "",
      scene_stack_id: "",
      scene_so_id: "",
      scene_flame_id: "",
      top: 20,
      top_so: 20,
      serch_input: "",
      serch_input_so: "",

      funcLoading: false,
      funcSoTrend: [],
      index_func: [],
      index_func_so: [],
      resBase64: [],
      edit_show: false,
      isInteger: true,
      options: ["Invert", "Traverse"],
      option_important: "Invert",
      option_memory: "Invert",
      scene_func_id_scene: "",
      level_trend: "",
      level_func: "",
      level_func_so: "",
      level_all: "",
      level_stack: "",
      scene_func_id_so: "",
      level_so: "",
      flame_so: "",
      base_id: "",
      editorOption: {
        theme: "snow", // 主题
        // debug: 'info',
        placeholder: "请输入其他说明",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              // ["blockquote",],
              [{ header: 1 }, { header: 2 }],

              [{ script: "sub" }, { script: "super" }],

              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],

              ["link"],

              // ["clean", "link", "image"]
              // ['addBtn']
            ], // 自定义工具栏选项
          },
        },
      },
      changeViewSo: true,
      changeViewMemory: true,
      contrast: true,
      version_head: [],
      size_head: [],
      
      flame_size_input: "",
      flame_size_stack_input: "",
      flame_so_input: [],
      flame_stack_so_input: [],
      flame_function_input: "",
      flame_stack_function_input: "",
      edit: false,
      // task_id: "",
      date_name: "",
      type_query: "",
      size_native: 10,
      page_native: 1,
      device_id: "",
      configShow: false,
      date: "",
      version: "",
      level: "",

      nativeVersionList: [],
      scene_id: "",
      scene_func_id: "",

      changeList: [],
      localProject: Number(getLocalProject()), //得到本地的项目
      
      formMail: {
        title: "", //标题
        Sender: "gamerobot@tencent.com", //发件人
        addressee: "", //收件人
        CC_List: "", //抄送人
      },
      valueTime: [],
      componentKey: 0,
      newCount: null,
      reserver: 1,
      order_by: "",
      reserver_so: 1,
      order_by_so: "",
      typeList: [
        { name: "增量", value: "2" },
        { name: "全量", value: "1" },
      ],
      type: "",
      nativeTableAllLoading: false,
      merge_show: true,
      stackV2Data: {
        decrease: {children: []},
        increase: {children: []},
        tree: {
          children: []
        },
      },
      add_show: false,
      delete_show: false,
      report_loading: false,
      moudle_loading: false,
      nativeAllHead: [
        // { new: "mallocNumber", old: "mallocNumberDiff", label: "TotalNativeMallocCount" },
        // { new: "mallocSize", old: "mallocSizeDiff", label: "TotalNativeMallocSize"},

        {
          new: "unreleasedSize",
          old: "unreleasedSizeDiff",
          label: "MallocSize",
        },
        {
          new: "unreleasedNumber",
          old: "unreleasedNumberDiff",
          label: "MallocCount",
        },
      ],
      nativeAllHead1: [
        // { new: "mallocNumber", old: "mallocNumberDiff", label: "TotalNativeMallocCount"},
        // { new: "mallocSize", old: "mallocSizeDiff", label: "TotalNativeMallocSize"},
        {
          new: "unreleasedSize",
          old: "unreleasedSizeDiff",
          label: "MallocSize",
        },
        {
          new: "unreleasedNumber",
          old: "unreleasedNumberDiff",
          label: "MallocCount",
        },
      ],
      nativeTableAll: [],
      nativeTableSoAll: [],
      // old_record_id: "",
      old_date: "",
      old_date_stack: "",
      old_so_date: "",
      old_version_base: "",
      old_version_so_base: "",
      old_version_stack: "",
      old_date_base_name: "",
      old_date_name: "",
      old_date_so_name: "",
      old_stack_name: "",
      flame_serch: "",
      changeView: true,
      dimension_scene: "",
      dimension_so: "",
      dimension_func: "",
      dimension_native: "",
      dimension_important: "",
      dimension_so_all: "",
      dimension_memory: "",
    }
  },

  watch: {
    perfettoStack_v2() {
      this.stackTableKey = Math.random()
      this.allStackData =  this.perfettoStack_v2 || {}
    }
  },

  methods: {
    old_record_id_created() {
      let num = 0;
      if (this.perfDateOptions.length > 1) {
        if (
          this.perfDateOptions[this.perfDateOptions.length - 1].name ==
          this.date_name
        ) {
          this.perfDateOptions.forEach((v, index) => {
            if (v.name == this.date_name) {
              num = index;
            }
          });
          this.old_date_name = this.perfDateOptions[num - 1].name;
          this.old_stack_name = this.perfDateOptions[num - 1].name;
          this.old_date_so_name = this.perfDateOptions[num - 1].name;
        } else {
          this.perfDateOptions.forEach((v, index) => {
            if (v.name == this.date_name) {
              num = index;
            }
          });
          this.old_date_name = this.perfDateOptions[num + 1].name;
          this.old_stack_name = this.perfDateOptions[num + 1].name;
          this.old_date_so_name = this.perfDateOptions[num + 1].name;
        }
        // this.perfDateOptions.forEach((v,index)=>{
        //   if(v.task_record_id==this.task_id){
        //     num=index
        //   }
        // })
        // if(num==(this.perfDateOptions.length-1)){

        // }
      } else {
        if (this.perfDateOptions.length > 0) {
          this.old_date_name = this.perfDateOptions[0].name;
          this.old_stack_name = this.perfDateOptions[0].name;
          this.old_date_so_name = this.perfDateOptions[0].name;
        }
      }
    },

    loading_created() {
      if (this.perfSceneOptions.filter((v) => v.name == "Loading").length > 0) {
        return this.perfSceneOptions.filter((v) => v.name == "Loading")[0]
          .scene_id;
      } else {
        return this.perfSceneOptions.length > 0
          ? this.perfSceneOptions[0].scene_id
          : "";
      }
    },

    async getAllDateOptions() {
      const {data} = await grAxios({
        url: 'xcode/date_option/',
        params: {
          project: this.localProject,
          report_type: this.type_query,
          type: this.type,
          device_id: this.device_id,
          level: this.level_all,
          scene: this.scene_natvie_id,
        }
      })

      this.allDateOptions = data.date_list
      this.old_date_name = this.allDateOptions[1]?.name || this.allDateOptions[0]?.name
    },

    async getLibDateOptions() {
      const {data} = await grAxios({
        url: 'xcode/date_option/',
        params: {
          project: this.localProject,
          report_type: this.type_query,
          type: this.type,
          device_id: this.device_id,
          level: this.level_so,
          scene: this.scene_so_id,
        }
      })

      this.libDateOptions = data.date_list
      this.old_date_so_name = this.libDateOptions[1]?.name || this.libDateOptions[0]?.name
    },

    addValueField(data) {
      if (data) {
        if (data?.Name == "root") {
          data.value = data?.self;
          data.name =
            data?.functionName +
            " " +
            (data?.self / 1024 / 1024).toFixed(2) +
            "MB";
        } else {
          data.value = data?.self;
          data.name = data?.functionName;
        }

        if (Array.isArray(data.children)) {
          data.children.forEach((child) => {
            this.addValueField2(child);
          });
        }
      }
    },

    //声明属性
    downLoadNew(data, type) {
      let functionData = this.xcodeReportData.risk_funcs;
      let soData = this.xcodeReportData.risk_so;
      
      let b = this.$message({
        //Message 消息提示
        message: "下载中,请耐心等待....",
        showClose: true,
        duration: 0,
      });
      this.dispatchXcodeFileName(store, {
        project: this.localProject,
        id: data.id,
      }).then((res) => {
        const link = document.createElement("a");
        this.dispatchPerfettoDownLoadDimensionStack(store, {
          project: this.localProject,
          id: data.id,
          old_id: data.old_id,
          func: type == "func" ? functionData[data.type][data.id].join(";") : "",
          so: type == "func" ? "" : soData[data.type][data.id].join(";"),
          dimension: data.dimensions,
        }).then((htmlContent) => {
          // 创建一个 Blob 对象来存储 HTML 内容
          const blob = new Blob([htmlContent], { type: "text/html" });

          // 创建一个指向 Blob 对象的 URL
          const url = URL.createObjectURL(blob);

          // 创建一个临时的 <a> 标签
          const link = document.createElement("a");
          link.href = url; // 设置链接为 Blob URL
          link.download = `${res.filename}${
            type == "func" ? "_function" : "_so"
          }.html`; // 设置下载文件的名称
          link.style.display = "none"; // 隐藏 <a> 标签

          // 将 <a> 标签添加到 DOM 中
          document.body.appendChild(link);

          // 触发点击事件以开始下载
          link.click();

          // 从 DOM 中移除 <a> 标签
          document.body.removeChild(link);

          // 释放 Blob URL
          URL.revokeObjectURL(url);
          b.close();
        });
      });
    },

    download(data, type, current) {
      let functionData = this.xcodeReportData.risk_funcs;
      let soData = this.xcodeReportData.risk_so;
      this.dispatchXcodeFileName(store, {
        project: this.localProject,
        id: type ? (current == 0 ? data.base.id : data.last.id) : data.current.id,
      }).then((res) => {
        const link = document.createElement("a");
        this.dispatchPerfettoDownLoadStack(store, {
          project: this.localProject,
          id: data.current.id,
          old_id: type ? (current == 0 ? data.base.id : data.last.id) : "",
          func: !type
            ? ""
            : current == 0
            ? functionData.base[data.current.id]
              ? functionData.base[data.current.id].join(";")
              : ""
            : functionData.last[data.current.id]
            ? functionData.last[data.current.id].join(";")
            : "",
          so: "",
        }).then((htmlContent) => {
          // 创建一个 Blob 对象来存储 HTML 内容
          const blob = new Blob([htmlContent], { type: "text/html" });

          // 创建一个指向 Blob 对象的 URL
          const url = URL.createObjectURL(blob);

          // 创建一个临时的 <a> 标签
          const link = document.createElement("a");
          link.href = url; // 设置链接为 Blob URL
          link.download = `${res.filename}${type ? "_function" : ""}.html`; // 设置下载文件的名称
          link.style.display = "none"; // 隐藏 <a> 标签

          // 将 <a> 标签添加到 DOM 中
          document.body.appendChild(link);

          // 触发点击事件以开始下载
          link.click();

          // 从 DOM 中移除 <a> 标签
          document.body.removeChild(link);

          // 释放 Blob URL
          URL.revokeObjectURL(url);
        });
        if (type) {
          this.dispatchPerfettoDownLoadStack(store, {
            project: this.localProject,
            id: data.current.id,
            old_id: type ? (current == 0 ? data.base.id : data.last.id) : "",
            func: "",
            so: !type
              ? ""
              : current == 0
              ? soData.base[data.current.id]
                ? soData.base[data.current.id].join(";")
                : ""
              : soData.last[data.current.id]
              ? soData.last[data.current.id].join(";")
              : "",
          }).then((htmlContent) => {
            console.log(htmlContent);
            // 创建一个 Blob 对象来存储 HTML 内容
            const blob = new Blob([htmlContent], { type: "text/html" });

            // 创建一个指向 Blob 对象的 URL
            const url = URL.createObjectURL(blob);

            // 创建一个临时的 <a> 标签
            const link = document.createElement("a");
            link.href = url; // 设置链接为 Blob URL
            link.download = `${res.filename}_so.html`; // 设置下载文件的名称
            link.style.display = "none"; // 隐藏 <a> 标签

            // 将 <a> 标签添加到 DOM 中
            document.body.appendChild(link);

            // 触发点击事件以开始下载
            link.click();

            // 从 DOM 中移除 <a> 标签
            document.body.removeChild(link);

            // 释放 Blob URL
            URL.revokeObjectURL(url);
          });
        }
      });
      // 创建一个临时的 <a> 标签

      // link.href = value; // 链接到需要下载的文件
      // link.download = "filename.txt"; // 设置下载文件的名称
      // link.style.display = "none"; // 隐藏 <a> 标签

      // // 将 <a> 标签添加到 DOM 中
      // document.body.appendChild(link);

      // // 触发点击事件以开始下载
      // link.click();

      // // 从 DOM 中移除 <a> 标签
      // document.body.removeChild(link);
    },
    
    async btnAll(scene, level) {
      //  this.backShow=true

      //   this.backShow=false

      const routeUrl = this.$router.resolve({
        path: "/dmo_perfetto",
        query: {
          project: this.localProject,
          level: level,
          scene_name: scene,
          device_id: this.device_id,
          date: this.date,
          version: this.version,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    
    async flameAllChangeSo() {
      this.flame_size_input = "";
      this.flame_so_input = [];
      this.flame_function_input = "";
      this.flameLoading = true;
      await this.dispatchXcodeStack(store, {
        project: this.localProject,
        level: this.flame_so,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.type_query,
        scene_name: this.scene_flame_id,
        size: this.flame_size_input,
        so: this.flame_so_input.join(";"),
        func: this.flame_function_input,
        type: this.type,
        dimension: this.dimension_memory,
        option: this.option_memory,
      });
      if (JSON.stringify(this.perfettoStack) === "{}") {
        this.flameShow = false;
        return;
      } else {
        this.flameShow = true;
        this.flame_check_data = false;
        this.$nextTick(() => {
          this.renderFlame("#chart", this.perfettoStack);
        });
      }

      this.flameLoading = false;
    },

    async downloadCsv() {
      this.nativeTableAllLoading = true;
      let b = this.$message({
        //Message 消息提示
        message: "导出中,请耐心等待....",
        showClose: true,
        duration: 0,
        customClass: "centered-message", // 添加自定义类名
      });

      const response_data = await this.dispatchXcodeNativeAllExport(store, {
        project: this.localProject,
        level: this.level_all,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_natvie_id,
        top: this.top,
        search: this.serch_input,
        old_date: this.old_date,
        old_version: this.old_version_base,
        order_by: this.order_by,
        reverse: this.reserver,
        type: this.type,
        dimension: this.dimension_native,
      });
      this.nativeTableAll = this.nativeAllData.slice(
        (this.page - 1) * this.size,
        this.page * this.size
      );
      response_data.then((value) => {
        // console.log(value);
        var elink = document.createElement("a");
        elink.download = "全量Native数据查看" + ".xls";
        elink.style.display = "none";
        var blob = new Blob([value], { type: "application/vnd.ms-excel" });

        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        b.close();
        this.nativeTableAllLoading = false;
      });
    },

    async btn(scene, level) {
      let type = {
        高画质: 1,
        中画质: 2,
        低画质: 3,
      };

      const routeUrl = this.$router.resolve({
        path: "/dmo_perfetto_unreleased",
        query: {
          project: this.localProject,
          level: level,
          scene_name: scene,
          device_id: this.device_id,
          date: this.date,
          version: this.version,
          // task_record_id: this.task_id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    downloadFile() {
      if (this.perfReportPkg === "") {
        ElMessage.error("无对应的流水线");
      } else {
        window.open(this.perfReportPkg, "_blank");
      }
    },
    
    async deleteBtn() {
      this.flame_size_input = "";
      this.flame_so_input = [];
      this.flame_function_input = "";
      this.report_loading = true;
      this.moudle_loading = true;
      this.funcLoading = true;
      this.nativeTableAllLoading = true;
      this.flameLoading = true;
      await this.dispatchDeleteXcode(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.type_query,
        type: this.type,
      });
      // await dispatchPerfettoOptions(store, {
      //   project: this.localProject,
      //   report_type: this.type_query,
      // });
      // if (this.perfDateOptions?.length > 0) {
      //   this.componentKey++;
      //   this.date_name = this.perfDateOptions[0].name;
      //   this.base_id = "";
      // } else {
      //   await dispatchPerfettoTypeOptions(store, {
      //     project: this.localProject,
      //   });
      //   this.type_query = this.perfTypeOptions[0].report_type;
      //   await dispatchPerfettoOptions(store, {
      //     project: this.localProject,
      //     report_type: this.type_query,
      //   });
      //   this.date_name = this.perfDateOptions[0].name;
      // }
      this.date = this.perfDateOptions.filter(
        (v) => v.name == this.date_name
      )[0].date;
      this.version = this.perfDateOptions.filter(
        (v) => v.name == this.date_name
      )[0].version;
      this.old_record_id_created();
      this.old_date = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_name
      )[0].date;
      this.old_date_stack = this.perfDateOptions.filter(
        (v) => v.name == this.old_stack_name
      )[0].date;
      this.old_so_date = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].date;
      this.old_version_base = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_name
      )[0].version;
      this.old_version_so_base = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].version;
      this.old_version_stack = this.perfDateOptions.filter(
        (v) => v.name == this.old_stack_name
      )[0].version;
      await this.dispatchXcodeDeviceOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,

        report_type: this.type_query,
        type: this.type,
      });
      this.device_id = this.perfDeviceOptions[0].device_id;
      await this.dispatchXcodeLevelOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,

        report_type: this.type_query,
        type: this.type,
        device_id: this.device_id,
      });
      await this.dispatchXcodeSceneOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,

        report_type: this.type_query,
        type: this.type,
        device_id: this.device_id,
      });

      this.scene_id = this.loading_created();
      this.scene_func_id = this.loading_created();
      this.scene_func_id_so = this.loading_created();
      this.scene_func_id_scene = this.loading_created();
      this.scene_natvie_id = this.loading_created();
      this.scene_stack_id = this.loading_created();
      this.scene_so_id = this.loading_created();
      this.scene_flame_id = this.loading_created();

      await this.dispatchXcodeReport(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: Number(this.type_query),
        type: this.type,
      });
      this.scene_flame =
        this.scene_flame_list?.length > 0 ? this.scene_flame_list[0] : "";
      this.level_flame =
        this.level_flame_list?.length > 0 ? this.level_flame_list[0] : "";
      this.so_scene_flame =
        this.scene_flame_so_list?.length > 0 ? this.scene_flame_so_list[0] : "";
      this.so_level_flame =
        this.level_flame_so_list?.length > 0 ? this.level_flame_so_list[0] : "";
      this.functions_flame = this.level_flame
        ? this.xcodeReportData.func_list[this.scene_flame][
            this.level_flame
          ].join(",")
        : "";
      this.so_flame = this.so_list?.length > 0 ? this.so_list : [];
      // this.functions_flame_api();
      // this.so_flame_api();
      this.report_loading = false;
      this.nativeHead();
      this.valueTime = [];
      await this.dispatchXcodeNativeTrend(store, {
        project: this.localProject,
        level: this.level,

        report_type: Number(this.type_query),
        start: "",
        end: "",
        type: this.type,

        scene_name: this.scene_func_id_scene,
      });
      this.resBase64 = [];
      this.edit_show = false;
      this.resBase64 = [];
      this.drawNativeTrend(this.device_id, this.level);

      await this.dispatchXcodeNativeFuncTrend(store, {
        project: this.localProject,
        level: this.level_func,

        report_type: Number(this.type_query),
        scene_name: this.scene_func_id,
        start: "",
        end: "",
        type: this.type,
        dimension: this.dimension_func,
      });
      this.index_func = this.funcTrend.func_list.filter((v, index) => index <= 4);
      this.drawNativeFuncTrend();
      let funcSoTrend = await this.dispatchXcodeSoList(store, {
        project: this.localProject,
        level: this.level_func_so,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_func_id_so,
        report_type: this.type_query,
        type: this.type,
        dimension: this.dimension_so,
      });
      this.funcSoTrend = funcSoTrend.map((item) => {
        return item.replace(/\+/g, "");
      });

      if (this.funcSoTrend.length > 0) {
        this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
        await this.dispatchXcodeSoFuncTrend(store, {
          project: this.localProject,
          level: this.level_func_so,

          report_type: Number(this.type_query),
          scene_name: this.scene_func_id_so,
          start: "",
          end: "",
          so_list: this.index_func_so,
          type: this.type,
          dimension: this.dimension_so,
        });
        this.drawSOFuncTrend();
      }

      this.funcLoading = false;
      await this.dispatchXcodeNativeModule(store, {
        project: this.localProject,
        level: this.level,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_id,
        report_type: this.type_query,
        type: this.type,
        dimension: this.dimension_important,
        option: this.option_important,
      });

      // this.Native_thread_important();
      this.moudle_loading = false;
      this.nativeAllChange();
      this.nativeAllChangeSo();
      await this.dispatchXcodeStack(store, {
        project: this.localProject,
        level: this.flame_so,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.type_query,
        size: this.flame_size_input,
        so: this.flame_so_input.join(";"),
        func: this.flame_function_input,
        scene_name: this.scene_flame_id,
        type: this.type,
        dimension: this.dimension_memory,
        option: this.option_memory,
      });
      if (JSON.stringify(this.perfettoStack) === "{}") {
        this.flameShow = false;
        return;
      } else {
        this.flameShow = true;
        this.flame_check_data = false;
        this.$nextTick(() => {
          this.renderFlame("#chart", this.perfettoStack);
        });
      }

      this.flameLoading = false;
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.date,
          version: this.version,
          old_date: this.old_date,
          old_version_base: this.old_version_base,
          device_id: this.device_id,
          type: this.type_query,
          level: encodeURIComponent(this.level),
          level_trend: encodeURIComponent(this.level_trend),
          level_func: encodeURIComponent(this.level_func),
          level_all: encodeURIComponent(this.level_all),
          scene_id: this.scene_id,
          scene_func_id: this.scene_func_id,
          scene_natvie_id: this.scene_natvie_id,
          typeof: this.type,
          // old_record_id: this.old_record_id,
        },
      });
    },
    text(num) {
      let text = "";
      let color = "";
      if (!isNaN(num)) {
        if (num > 0) {
          text = num + "↑";
          color = "red";
        } else if (num < 0) {
          text = Math.abs(num) + "↓";
          color = "#00b050";
        } else {
          text = "0";
          color = "#606266";
        }
      } else {
        text = num;
        color = "#606266";
      }
      return [text, color];
    },
    async settingsBtn() {
      this.report_loading = true;
      this.moudle_loading = true;
      this.configShow = false;
      // let obj: any = {
      //   perfetto_set: {
      //     name: this.base_id
      //       ? this.perfDateOptions.filter((v) => v.name == this.base_id)[0].date +
      //         " " +
      //         this.perfDateOptions.filter((v) => v.name == this.base_id)[0]
      //           .version
      //       : "",
      //   },
      // };
      this.settings.xcode_set = {};
      this.settings.xcode_set.name = this.base_id
        ? this.perfDateOptions.filter((v) => v.name == this.base_id)[0].date +
          " " +
          this.perfDateOptions.filter((v) => v.name == this.base_id)[0].version
        : "";
      let obj = this.settings;
      obj = JSON.stringify(obj);

      await this.dispatchPerfettoSettingsEdit(store, {
        project: this.localProject,
        settings: obj,
      });
      await this.dispatchXcodeReport(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: Number(this.type_query),
        type: this.type,
      });
      this.nativeHead();
      this.dispatchXcodeNativeModule(store, {
        project: this.localProject,
        level: this.level,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_id,
        report_type: this.type_query,
        type: this.type,
        dimension: this.dimension_important,
        option: this.option_important,
      });
      this.report_loading = false;
      this.moudle_loading = false;
    },
    
    async trendChange() {
      // this.valueTime=[]
      let startTimeAll = "";
      let endTimeAll = "";
      if (this.valueTime) {
        startTimeAll =
          dateConversion(this.valueTime[0]) == "-"
            ? ""
            : dateConversion(this.valueTime[0]);
        endTimeAll =
          dateConversion(this.valueTime[1]) == "-"
            ? ""
            : dateConversion(this.valueTime[1]);
      } else {
        startTimeAll = "";
        endTimeAll = "";
      }
      await this.dispatchXcodeNativeTrend(store, {
        project: this.localProject,
        level: this.level_trend,

        report_type: Number(this.type_query),
        start: startTimeAll,
        end: endTimeAll,
        type: this.type,

        scene_name: this.scene_func_id_scene,
      });
      this.resBase64 = [];

      this.drawNativeTrend(this.device_id, this.level);
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.date,
          version: this.version,
          old_date: this.old_date,
          old_version_base: this.old_version_base,
          device_id: this.device_id,
          type: this.type_query,
          level: encodeURIComponent(this.level),
          level_trend: encodeURIComponent(this.level_trend),
          level_func: encodeURIComponent(this.level_func),
          level_all: encodeURIComponent(this.level_all),
          scene_id: this.scene_id,
          scene_func_id: this.scene_func_id,
          scene_natvie_id: this.scene_natvie_id,
          typeof: this.type,
          // old_record_id: this.old_record_id,
        },
      });
    },
    
    
    async importantChange() {
      this.moudle_loading = true;
      this.page_native = 1;
      this.size_native = 10;
      await this.dispatchXcodeNativeModule(store, {
        project: this.localProject,
        level: this.level,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_id,
        report_type: this.type_query,
        type: this.type,
        dimension: this.dimension_important,
        option: this.option_important,
      });
      this.moudle_loading = false;
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.date,
          version: this.version,
          old_date: this.old_date,
          old_version_base: this.old_version_base,
          device_id: this.device_id,
          type: this.type_query,
          level: encodeURIComponent(this.level),
          level_trend: encodeURIComponent(this.level_trend),
          level_func: encodeURIComponent(this.level_func),
          level_all: encodeURIComponent(this.level_all),
          scene_id: this.scene_id,
          scene_func_id: this.scene_func_id,
          scene_natvie_id: this.scene_natvie_id,
          typeof: this.type,
          // old_record_id: this.old_record_id,
        },
      });
      // this.Native_thread_important();
    },
    risk(risk) {
      if (risk === "高风险") {
        return "red";
      } else if (risk == "中风险") {
        return "orange";
      } else {
        return "rgb(0, 176, 80)";
      }
    },
    
    getnum(data, item) {
      console.log(data, item);
    },
    async save_report() {
      let b = this.$message({
        //Message 消息提示
        message: "发送报告中...",
        showClose: true,
        duration: 0,
      });
      let startTimeAll = "";
      let endTimeAll = "";
      this.resBase64 = [];
      if (this.valueTime) {
        startTimeAll =
          dateConversion(this.valueTime[0]) == "-"
            ? ""
            : dateConversion(this.valueTime[0]);
        endTimeAll =
          dateConversion(this.valueTime[1]) == "-"
            ? ""
            : dateConversion(this.valueTime[1]);
      } else {
        startTimeAll = "";
        endTimeAll = "";
      }

      for (const v of this.perfDeviceOptions) {
        await this.dispatchXcodeLevelOptions(store, {
          project: this.localProject,
          date: this.date,
          version: this.version,

          report_type: this.type_query,
          type: this.type,
          device_id: this.device_id,
        });
        await this.dispatchXcodeSceneOptions(store, {
          project: this.localProject,
          date: this.date,
          version: this.version,

          report_type: this.type_query,
          type: this.type,
          device_id: this.device_id,
        });
        await this.dispatchXcodeDimensOptions(store, {
          project: this.localProject,
          date: this.date,
          version: this.version,

          report_type: this.type_query,
          type: this.type,
          device_id: this.device_id,
        });

        for (let i of this.perfLeveOptions) {
          for (let m of this.perfSceneOptions) {
            await this.dispatchXcodeNativeTrend(store, {
              project: this.localProject,
              level: i.level,

              report_type: Number(this.type_query),
              start: startTimeAll,
              end: endTimeAll,
              type: this.type,
              scene_name: m.scene_id,
            });
            this.drawNativeTrend(v.device_id, i.level, m.scene_id);
            for (let x of this.dimensionsList) {
              let funcSoTrend = await this.dispatchXcodeSoList(store, {
                project: this.localProject,
                level: i.level,
                device_id: this.device_id,
                date: this.date,
                version: this.version,
                scene_name: m.scene_id,
                report_type: this.type_query,
                type: this.type,
                dimension: x.type,
              });
              this.funcSoTrend = funcSoTrend.map((item) => {
                return item.replace(/\+/g, "");
              });
              if (this.funcSoTrend.length > 0) {
                let index_func_so = this.funcSoTrend.filter(
                  (v, index) => index <= 9
                );
                await this.dispatchXcodeSoFuncTrend(store, {
                  project: this.localProject,
                  level: i.level,

                  report_type: Number(this.type_query),
                  scene_name: m.scene_id,
                  start: "",
                  end: "",
                  so_list: index_func_so,
                  type: this.type,
                  dimension: x.type,
                });
                this.drawSOFuncTrend(v.device_id, i.level, m.scene_id, x.type);
              }
            }
          }
        }
      }
      // this.perfDeviceOptions.forEach(v=>{
      //   await dispatchPerfettoNativeTrend(store, {
      //   project: this.localProject,
      //   level: this.level,
      //   device_id: Number(this.device_id),
      //   report_type: Number(this.type_query),
      //   start:'',
      //   end:''

      // });
      // this.drawNativeTrend();
      // })
      await this.dispatchUploadXcodeReport(store, {
        project: this.localProject,
        device_id: this.device_id,
        scene_name: this.scene_id,
        level: Number(this.level_func_so),
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        send: this.formMail.Sender,
        file_list: this.resBase64,
        report_type: this.type_query,
        url: window.location.href,
        date: this.date,
        version: this.version,
        old_date: this.perfDateOptions.filter(
          (v) => v.name == this.old_date_so_name
        )[0].date,
        old_version: this.perfDateOptions.filter(
          (v) => v.name == this.old_date_so_name
        )[0].version,
        type: this.type,
      });
      b.close();
      ElMessage.success({
        message: "报告发送成功",
        showClose: true,
        type: "success",
      });
      //  this.device_id=this.perfDeviceOptions[0].device_id
      await this.dispatchXcodeLevelOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,

        report_type: this.type_query,
        type: this.type,
        device_id: this.device_id,
      });
      await this.dispatchXcodeSceneOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,

        report_type: this.type_query,
        type: this.type,
        device_id: this.device_id,
      });

      // this.level = this.perfLeveOptions[0].level;
      await this.dispatchXcodeNativeTrend(store, {
        project: this.localProject,
        level: this.level_trend,

        report_type: Number(this.type_query),
        start: startTimeAll,
        end: endTimeAll,
        type: this.type,

        scene_name: this.scene_func_id_scene,
      });
      let funcSoTrend = await this.dispatchXcodeSoList(store, {
        project: this.localProject,
        level: this.level_func_so,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_func_id_so,
        report_type: this.type_query,
        type: this.type,
        dimension: this.dimension_so,
      });
      this.funcSoTrend = funcSoTrend.map((item) => {
        return item.replace(/\+/g, "");
      });
      if (this.funcSoTrend.length > 0) {
        this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
        await this.dispatchXcodeSoFuncTrend(store, {
          project: this.localProject,
          level: this.level,

          report_type: Number(this.type_query),
          scene_name: this.scene_id,
          start: "",
          end: "",
          so_list: this.index_func_so,
          type: this.type,
          dimension: this.dimension_so,
        });
        this.drawSOFuncTrend();
      }

      this.drawNativeTrend(this.device_id, this.level);
    },
    risk_color(num) {
      let text = "";
      let color = "";
      if (typeof num == "number") {
        if (num < 0) {
          text = Math.abs(num) + "↓";
        } else {
          text = Math.abs(num) + "↑";
          if (num >= 10 && num <= 30) {
            color = "orange";
          } else if (num < 10) {
            color = "rgb(0, 176, 80)";
          } else if (num > 30) {
            color = "red";
          }
        }
      } else {
        text = num;
      }
      return [text, color];
    },

    // 祖传合并
    mergeCells({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.nativeModuleData.filter(
          (item) => item.parent === row.parent
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.nativeModuleData.findIndex(
              (item) => item.parent === row.parent
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 1) {
        const rowCount = this.nativeModuleData.filter(
          (item) => item.sub === row.sub
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.nativeModuleData.findIndex((item) => item.sub === row.sub) ===
            rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },
    mergeCells1({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.perfReport_top.filter(
          (item) => item.level === row.level
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.perfReport_top.findIndex((item) => item.level === row.level) ===
            rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 1) {
        const rowCount = this.perfReport_top.filter(
          (item) => item.version === row.version
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.perfReport_top.findIndex(
              (item) => item.version === row.version
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 2 || columnIndex === 5) {
        const rowCount = this.perfReport_top.filter(
          (item) => item.scene === row.scene && item.version === row.version
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.perfReport_top.findIndex(
              (item) => item.scene === row.scene && item.version === row.version
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 4) {
        const rowCount = this.perfReport_top.filter(
          (item) =>
            item.memory_diff === row.memory_diff && item.diif_new === row.diif_new
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.perfReport_top.findIndex(
              (item) =>
                item.memory_diff === row.memory_diff &&
                item.diif_new === row.diif_new
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },
    mergeCells_so({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.perfReport_so_top.filter(
          (item) => item.level === row.level
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.perfReport_so_top.findIndex(
              (item) => item.level === row.level
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 1) {
        const rowCount = this.perfReport_so_top.filter(
          (item) => item.version === row.version
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.perfReport_so_top.findIndex(
              (item) => item.version === row.version
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 2 || columnIndex === 5) {
        const rowCount = this.perfReport_so_top.filter(
          (item) => item.scene === row.scene && item.version === row.version
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.perfReport_so_top.findIndex(
              (item) => item.scene === row.scene && item.version === row.version
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 4) {
        const rowCount = this.perfReport_so_top.filter(
          (item) =>
            item.memory_diff === row.memory_diff && item.diif_new === row.diif_new
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.perfReport_so_top.findIndex(
              (item) =>
                item.memory_diff === row.memory_diff &&
                item.diif_new === row.diif_new
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },
    mergeCells2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowCount = this.nativeData.filter((item) => item.name === row.name)
          .length;
        if (rowCount > 1) {
          const isFirstRow =
            this.nativeData.findIndex((item) => item.name === row.name) ===
            rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 1) {
        const rowCount = this.nativeData.filter(
          (item) => item.name === row.name && item.picture === row.picture
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.nativeData.findIndex(
              (item) => item.name === row.name && item.picture === row.picture
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 2) {
        const rowCount = this.nativeData.filter(
          (item) =>
            item.name === row.name &&
            item.picture === row.picture &&
            item.latitude === row.latitude
        ).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.nativeData.findIndex(
              (item) =>
                item.name === row.name &&
                item.picture === row.picture &&
                item.latitude === row.latitude
            ) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    },

    sendOut() {
      this.edit = !this.edit;
    },
    drawNativeTrend(device, level, scene, dimension) {
      let data = [];

      this.nativeTrendData.scene_list.forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心
          data: this.nativeTrendData.series[index],
        });
      });

      let performance_line = document.getElementById("native_trend");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        tooltip: {
          trigger: "axis",
        },

        legend: {
          type: "scroll",
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0],
          // data: devices.map(
          //   (item) =>
          //     this.getDeviceSpecs.filter(
          //       (device) => device.id === item.device_id
          //     )[0]?.model.name
          // ),
        },
        yAxis: {
          type: "value",
          name: "MB",
          //  nameLocation: "top",
          // 坐标轴名称与轴线之间的距离。
          // nameGap: 35,
          // nameRotate: 90,
          axisTick: false,
          //左侧线
          // axisLine: {
          //   show: true,
          // },
          //  splitLine: {
          //   show: true,
          // },
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "10%",
          right: "4%",
          containLabel: true,
        },
        animation: false,
        xAxis: {
          type: "category",
          data: this.nativeTrendData.date_list,
        },

        series: data,
      });
      var res_base64 = contrastChart.getDataURL({
        excludeComponents: ["toolbox"],
      }); //拿到base64 地址，就好下载了。
      let res = {};
      //     const regex = /- (.+?) -/;
      let match = this.perfDeviceOptions
        .filter((v) => v.device_id == device)[0]
        .name.split("-");
      // const match = this.perfDeviceOptions.filter((v) => v.device_id == device)[0].name.match(regex);
      res.file_base64 = res_base64;
      res.filename = "memory" + "-" + device + "-" + level + "-" + scene + ".png";
      res.chinese =
        scene +
        "-" +
        this.perfLeveOptions.filter((v) => v.level == level)[0].name;
      this.resBase64.push(res);
    },
    drawNativeFuncTrend() {
      let data = [];

      let indexes = this.funcTrend.func_list
        .filter((item, index) => {
          return this.index_func.indexOf(item) !== -1;
        })
        .map((item) => this.funcTrend.func_list.indexOf(item));

      indexes.forEach((v, index) => {
        data.push({
          name: this.funcTrend.func_list[v],
          type: "line",
          symbol: "circle", //拐点设置为实心
          data: this.funcTrend.series[v],
        });
      });

      let performance_line = document.getElementById("native_func_trend");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        tooltip: {
          trigger: "axis",
        },

        legend: {
          type: "scroll",
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0],
          // data: devices.map(
          //   (item) =>
          //     this.getDeviceSpecs.filter(
          //       (device) => device.id === item.device_id
          //     )[0]?.model.name
          // ),
        },
        yAxis: {
          type: "value",
          name: "MB",
          //  nameLocation: "top",
          // 坐标轴名称与轴线之间的距离。
          // nameGap: 35,
          // nameRotate: 90,
          axisTick: false,
          //左侧线
          // axisLine: {
          //   show: true,
          // },
          //  splitLine: {
          //   show: true,
          // },
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "10%",
          right: "4%",
          containLabel: true,
        },
        animation: false,
        xAxis: {
          type: "category",
          data: this.funcTrend.date_list,
        },

        series: data,
      });
      // var res_base64 = contrastChart.getDataURL({
      //   excludeComponents: ["toolbox"],
      // }); //拿到base64 地址，就好下载了。
      // let res: any = {};
      // res.file_base64 = res_base64;
      // res.filename = 'func_trend.png';
      // res.chinese ='画质:'+ this.perfLeveOptions.filter(
      //   (v) => v.level == this.level_func
      // )[0].name;
      // this.resBase64.push(res);
    },
    async flame_btn() {
      this.flameLoading = true;
      this.isInteger = Number.isInteger(Number(this.flame_size_input));
      if (this.isInteger == false) {
        ElMessage.error("size请输入整数");
        this.flameLoading = false;
        return;
      }
      await this.dispatchXcodeStack(store, {
        project: this.localProject,
        level: this.flame_so,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.type_query,
        scene_name: this.scene_flame_id,
        size: this.flame_size_input,
        so: this.flame_so_input.join(";"),
        func: this.flame_function_input,
        type: this.type,
        dimension: this.dimension_memory,
        option: this.option_memory,
      });
      if (JSON.stringify(this.perfettoStack) === "{}") {
        this.flameShow = false;
        return;
      } else {
        this.flameShow = true;
        this.flame_check_data = true;
        this.$nextTick(() => {
          this.renderFlame("#chart", this.perfettoStack);
        });
      }
      this.flameLoading = false;
    },
    async flame_btn_stack() {
      this.flameLoadingStack = true;
      this.isInteger = Number.isInteger(Number(this.flame_size_input));
      if (this.isInteger == false) {
        ElMessage.error("size请输入整数");
        this.flameLoadingStack = false;
        return;
      }

      this.stack_v2_api();
    },
    drawSOFuncTrend(device, level, scene, dimension) {
      let data = [];

      // console.log(indexes)
      this.soTrend.so_list.forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心
          data: this.soTrend.series[index],
        });
      });

      let performance_line = document.getElementById("so_func_trend");
      echarts.dispose(performance_line);
      var contrastChart = echarts.init(performance_line);
      contrastChart.setOption({
        tooltip: {
          trigger: "axis",
        },

        legend: {
          type: "scroll",
          x: "center",
          y: "bottom",
          padding: [0, 0, 10, 0],
          // data: devices.map(
          //   (item) =>
          //     this.getDeviceSpecs.filter(
          //       (device) => device.id === item.device_id
          //     )[0]?.model.name
          // ),
        },
        yAxis: {
          type: "value",
          name: "MB",
          //  nameLocation: "top",
          // 坐标轴名称与轴线之间的距离。
          // nameGap: 35,
          // nameRotate: 90,
          axisTick: false,
          //左侧线
          // axisLine: {
          //   show: true,
          // },
          //  splitLine: {
          //   show: true,
          // },
        },
        grid: {
          left: "4%",
          top: "10%",
          bottom: "10%",
          right: "4%",
          containLabel: true,
        },
        animation: false,
        xAxis: {
          type: "category",
          data: this.soTrend.date_list,
        },

        series: data,
      });
      if (device && level) {
        var res_base64 = contrastChart.getDataURL({
          excludeComponents: ["toolbox"],
        }); //拿到base64 地址，就好下载了。
        let res = {};
        //     const regex = /- (.+?) -/;
        let match = this.perfDeviceOptions
          .filter((v) => v.device_id == device)[0]
          .name.split("-");
        // const match = this.perfDeviceOptions.filter((v) => v.device_id == device)[0].name.match(regex);
        res.file_base64 = res_base64;
        res.filename =
          "so_trend" +
          "-" +
          device +
          "-" +
          level +
          "-" +
          scene +
          "-" +
          dimension +
          ".png";
        res.chinese =
          scene +
          "-" +
          this.perfLeveOptions.filter((v) => v.level == level)[0].name +
          "-" +
          dimension;
        this.resBase64.push(res);
      }
    },
    funcChange() {
      this.drawNativeFuncTrend();
    },

    async funcChange_so() {
      let startTimeAll = "";
      let endTimeAll = "";
      if (this.valueTime) {
        startTimeAll =
          dateConversion(this.valueTime[0]) == "-"
            ? ""
            : dateConversion(this.valueTime[0]);
        endTimeAll =
          dateConversion(this.valueTime[1]) == "-"
            ? ""
            : dateConversion(this.valueTime[1]);
      } else {
        startTimeAll = "";
        endTimeAll = "";
      }
      await this.dispatchXcodeSoFuncTrend(store, {
        project: this.localProject,
        level: this.level_func_so,

        report_type: Number(this.type_query),
        scene_name: this.scene_func_id_so,
        start: startTimeAll,
        end: endTimeAll,
        so_list: this.index_func_so,
        type: this.type,
        dimension: this.dimension_so,
      });
      this.drawSOFuncTrend();
    },
    async funcChange_api_so() {
      let startTimeAll = "";
      let endTimeAll = "";
      if (this.valueTime) {
        startTimeAll =
          dateConversion(this.valueTime[0]) == "-"
            ? ""
            : dateConversion(this.valueTime[0]);
        endTimeAll =
          dateConversion(this.valueTime[1]) == "-"
            ? ""
            : dateConversion(this.valueTime[1]);
      } else {
        startTimeAll = "";
        endTimeAll = "";
      }
      let funcSoTrend = await this.dispatchXcodeSoList(store, {
        project: this.localProject,
        level: this.level_func_so,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_func_id_so,
        report_type: this.type_query,
        type: this.type,
        dimension: this.dimension_so,
      });
      this.funcSoTrend = funcSoTrend.map((item) => {
        return item.replace(/\+/g, "");
      });
      this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
      await this.dispatchXcodeSoFuncTrend(store, {
        project: this.localProject,
        level: this.level_func_so,

        report_type: Number(this.type_query),
        scene_name: this.scene_func_id_so,
        start: startTimeAll,
        end: endTimeAll,
        so_list: this.index_func_so,
        type: this.type,
        dimension: this.dimension_so,
      });
      this.drawSOFuncTrend();
    },
    check_view_memory() {
      this.changeViewMemory = !this.changeViewMemory;
      this.$nextTick(() => {
        if (this.flame_check_data == false) {
          this.renderFlame("#chart", this.perfettoStack);
        } else {
          this.$nextTick(() => {
            this.renderFlame("#chart", this.perfettoStack);
          });
        }
      });
    },
    async funcChange_api() {
      this.funcLoading = true;
      let startTimeAll = "";
      let endTimeAll = "";
      if (this.valueTime) {
        startTimeAll =
          dateConversion(this.valueTime[0]) == "-"
            ? ""
            : dateConversion(this.valueTime[0]);
        endTimeAll =
          dateConversion(this.valueTime[1]) == "-"
            ? ""
            : dateConversion(this.valueTime[1]);
      } else {
        startTimeAll = "";
        endTimeAll = "";
      }
      await this.dispatchXcodeNativeFuncTrend(store, {
        project: this.localProject,
        level: this.level_func,

        report_type: Number(this.type_query),
        scene_name: this.scene_func_id,
        start: startTimeAll,
        end: endTimeAll,
        type: this.type,
        dimension: this.dimension_func,
      });
      this.index_func = this.funcTrend.func_list.filter((v, index) => index <= 4);
      this.drawNativeFuncTrend();
      this.funcLoading = false;
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.date,
          version: this.version,
          old_date: this.old_date,
          old_version_base: this.old_version_base,
          device_id: this.device_id,
          type: this.type_query,
          level: encodeURIComponent(this.level),
          level_trend: encodeURIComponent(this.level_trend),
          level_func: encodeURIComponent(this.level_func),
          level_all: encodeURIComponent(this.level_all),
          scene_id: this.scene_id,
          scene_func_id: this.scene_func_id,
          scene_natvie_id: this.scene_natvie_id,
          typeof: this.type,
          // old_record_id: this.old_record_id,
        },
      });
    },
    async timeChange() {
      let startTimeAll = "";
      let endTimeAll = "";
      if (this.valueTime) {
        startTimeAll =
          dateConversion(this.valueTime[0]) == "-"
            ? ""
            : dateConversion(this.valueTime[0]);
        endTimeAll =
          dateConversion(this.valueTime[1]) == "-"
            ? ""
            : dateConversion(this.valueTime[1]);
      } else {
        startTimeAll = "";
        endTimeAll = "";
      }

      await this.dispatchXcodeNativeTrend(store, {
        project: this.localProject,
        level: this.level_trend,

        report_type: Number(this.type_query),
        start: startTimeAll,
        end: endTimeAll,
        type: this.type,

        scene_name: this.scene_func_id_scene,
      });
      await this.dispatchXcodeNativeFuncTrend(store, {
        project: this.localProject,
        level: this.level_func,

        report_type: Number(this.type_query),
        scene_name: this.scene_func_id,
        start: startTimeAll,
        end: endTimeAll,
        type: this.type,
        dimension: this.dimension_func,
      });
      this.resBase64 = [];
      this.drawNativeTrend(this.device_id, this.level);
      this.drawNativeFuncTrend();
    },
    screen(item) {
      if (item == "func") {
        const { href } = this.$router.resolve({
          path: "/full_screen_display",
          query: {
            ...this.$route.query,
            type: item,
            check: this.changeView,
            level: this.level_flame,
            date: this.date,
            version: this.version,
            device_id: this.device_id,
            report_type: this.type_query,
            scene_name: this.scene_flame,
            func: this.functions_flame,
          },
        });
        window.open(href, "_blank");
      }
      if (item == "so") {
        const { href } = this.$router.resolve({
          path: "/full_screen_display",
          query: {
            ...this.$route.query,
            type: item,
            check: this.changeViewSo,
            level: this.so_level_flame,
            date: this.date,
            version: this.version,
            device_id: this.device_id,
            report_type: this.type_query,
            scene_name: this.so_scene_flame,
            so: this.so_flame.length > 0 ? this.so_flame : "",
            is_all: this.type,
          },
        });
        window.open(href, "_blank");
      }
      if (item == "memory_xcode") {
        const { href } = this.$router.resolve({
          path: "/full_screen_display",
          query: {
            type: item,
            check: this.changeViewMemory,
            level: encodeURIComponent(this.flame_so),
            date: this.date,
            version: this.version,
            device_id: this.device_id,
            report_type: this.type_query,
            scene_name: this.scene_flame_id,
            size: this.flame_size_input,
            so: this.flame_so_input.length > 0 ? this.flame_so_input : "",
            func: this.flame_function_input,
            is_all: this.type,
            dimension: this.dimension_memory,
            option: this.option_memory,
          },
        });
        window.open(href, "_blank");
      }
      if (item == "merge") {
        const { href } = this.$router.resolve({
          path: "/full_screen_display",
          query: {
            ...this.$route.query,
            type: item,
            check: this.changeViewMemory,
            level: this.level_stack,
            date: this.date,
            version: this.version,
            device_id: this.device_id,
            report_type: this.type_query,
            scene_name: this.scene_stack_id,
            size: this.flame_size_stack_input,
            so:
              this.flame_stack_so_input.length > 0
                ? this.flame_stack_so_input
                : "",
            func: this.flame_stack_function_input,
            old_date_name: this.old_date_name,
            old_date_stack: this.old_date_stack,
            old_version_stack: this.old_version_stack,
            is_all: this.type,
          },
        });
        window.open(href, "_blank");
      }
      if (item == 'ios-merge') {
        const { href } = this.$router.resolve({
          path: "/full_screen_display",
          query: {
            ...this.$route.query,
            type: item,
            check: this.changeViewMemory,
            old_date_name: this.old_date_name,
            old_date_stack: this.old_date_stack,
            old_version_stack: this.old_version_stack,
            is_all: this.type,
            dimension_so: this.dimension_so,

            level: encodeURIComponent(this.level_stack),
            date: this.date,
            version: this.version,
            device_id: this.device_id,
            report_type: this.type_query,
            scene_name: this.scene_stack_id,
            size: this.flame_size_stack_input,
            so: this.flame_stack_so_input.join(','),
            func: this.flame_stack_function_input,
            old_date: this.old_date_stack,
            old_version: this.old_version_stack,
            //type: this.type,
            dimension: this.dimension_memory,
            option: this.option_memory,
          },
        });
        window.open(href, "_blank");
      }
    },
    nativeHead() {
      let list = ["current"];
      let list1 = ["当前版本"];
      let change = ["基线变化值", "前后变化值"];
      let target = ["unreleaseMallocSize"];
      this.nativeVersionList = [];
      this.changeList = [];

      list.forEach((v, index) => {
        this.nativeVersionList.push({
          head: list1[index],
          label: v,
          target: target,
          value: this.nativeData[0]?.data[v]?.version,
        });
      });
      change.forEach((v) => {
        this.changeList.push({
          head: v,
          i: ["unreleaseMallocSize"],
          color:
            v == "基线变化值" ? ["base_released_color"] : ["last_released_color"],
          target: v == "基线变化值" ? ["ReleaseBaseDiff"] : ["ReleaseLastDiff"],
          value:
            v == "基线变化值"
              ? this.nativeData[0]?.data?.base?.version
              : this.nativeData[0]?.data?.last?.version,
        });
      });
    },
    async memoryChange(item) {
      if (item.includes("is_all")) {
        await this.dispatchXcodeTypeOptions(store, {
          project: this.localProject,
          type: this.type,
        });
        this.type_query =
          this.perfTypeOptions.length > 0
            ? this.perfTypeOptions[0].report_type
            : "";
      }
      if (item.includes("report_type")) {
        await this.dispatchXcodeDateOptions(store, {
          project: this.localProject,
          report_type: this.type_query,
          type: this.type,
        });
        this.componentKey++;
        this.date_name =
          this.perfDateOptions.length > 0 ? this.perfDateOptions[0].name : "";
        this.date =
          this.perfDateOptions.length > 0 ? this.perfDateOptions[0].date : "";
        this.version =
          this.perfDateOptions.length > 0 ? this.perfDateOptions[0].version : "";
        this.old_record_id_created();
        if (this.perfDateOptions.length > 0) {
          this.old_date = this.perfDateOptions.filter(
            (v) => v.name == this.old_date_name
          )[0].date;
          this.old_date_stack = this.perfDateOptions.filter(
            (v) => v.name == this.old_stack_name
          )[0].date;
          this.old_version_base = this.perfDateOptions.filter(
            (v) => v.name == this.old_date_name
          )[0].version;
          this.old_so_date = this.perfDateOptions.filter(
            (v) => v.name == this.old_date_so_name
          )[0].date;
          this.old_date_base_name = this.perfDateOptions.filter(
            (v) => v.name == this.old_date_so_name
          )[0].version;
          this.old_version_stack = this.perfDateOptions.filter(
            (v) => v.name == this.old_stack_name
          )[0].version;
        }

        this.base_id = "";
        // this.type_query = this.perfDateOptions.filter(
        //   (v) => v.task_record_id == this.task_id
        // )[0].report_type;
      }
      if (item.includes("task_id")) {
        if (this.perfDateOptions.length > 0) {
          this.date = this.perfDateOptions.filter(
            (v) => v.name == this.date_name
          )[0].date;
          this.version = this.perfDateOptions.filter(
            (v) => v.name == this.date_name
          )[0].version;
          this.old_record_id_created();
          this.old_date = this.perfDateOptions.filter(
            (v) => v.name == this.old_date_name
          )[0].date;
          this.old_date_stack = this.perfDateOptions.filter(
            (v) => v.name == this.old_stack_name
          )[0].date;
          this.old_version_base = this.perfDateOptions.filter(
            (v) => v.name == this.old_date_name
          )[0].version;
          this.old_so_date = this.perfDateOptions.filter(
            (v) => v.name == this.old_date_so_name
          )[0].date;
          this.old_version_so_base = this.perfDateOptions.filter(
            (v) => v.name == this.old_date_so_name
          )[0].version;
          this.old_version_stack = this.perfDateOptions.filter(
            (v) => v.name == this.old_stack_name
          )[0].version;
        }

        await this.dispatchXcodeDeviceOptions(store, {
          project: this.localProject,
          date: this.date,
          version: this.version,

          report_type: this.type_query,
          type: this.type,
        });
        
        const defaultOption = this.perfDeviceOptions.find(item => item.name.includes('J200')) || this.perfDeviceOptions[0]
        this.device_id = defaultOption?.device_id + ''

        // this.type_query = this.perfDateOptions.filter(
        //   (v) => v.task_record_id == this.task_id
        // )[0].report_type;
      }
      if (item.includes("device_id")) {
        await this.dispatchXcodeDimensOptions(store, {
          project: this.localProject,
          date: this.date,
          version: this.version,

          report_type: this.type_query,
          type: this.type,
          device_id: this.device_id,
        });
        this.dimension_scene = this.dimensionsList[0].type;
        this.dimension_so = this.dimensionsList[0].type;
        this.dimension_func = this.dimensionsList[0].type;
        this.dimension_native = this.dimensionsList[0].type;
        this.dimension_important = this.dimensionsList[0].type;
        this.dimension_so_all = this.dimensionsList[0].type;
        this.dimension_memory = this.dimensionsList[0].type;
      }
      await this.dispatchXcodeLevelOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,

        report_type: this.type_query,
        type: this.type,
        device_id: this.device_id,
      });

      this.level =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_trend =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_func =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_func_so =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_all =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_stack =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_so =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.flame_so =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      await this.dispatchXcodeSceneOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,

        report_type: this.type_query,
        type: this.type,
        device_id: this.device_id,
      });

      this.scene_id = this.loading_created();
      this.scene_func_id = this.loading_created();
      this.scene_func_id_so = this.loading_created();
      this.scene_func_id_scene = this.loading_created();
      this.scene_natvie_id = this.loading_created();
      this.scene_stack_id = this.loading_created();
      this.scene_so_id = this.loading_created();
      this.scene_flame_id = this.loading_created();

      this.getAllDateOptions()
      this.getLibDateOptions()
    },
    
    async sort_change(column) {
      this.page = 1;

      this.nativeTableAllLoading = true;
      this.reserver = column.order ? (column?.order == "ascending" ? 0 : 1) : "";
      this.order_by = column.prop ? column.prop : "";
      await this.dispatchXcodeNativeAll(store, {
        project: this.localProject,
        level: this.level_all,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_natvie_id,
        top: this.top,
        search: this.serch_input,
        old_date: this.old_date,
        old_version: this.old_version_base,
        order_by: this.order_by,
        reverse: this.reserver,
        type: this.type,
        dimension: this.dimension_native,
      });
      this.nativeTableAll = this.nativeAllData.slice(
        (this.page - 1) * this.size,
        this.page * this.size
      );
      this.nativeTableAllLoading = false;
    },
    async sort_change_so(column) {
      this.page_so = 1;

      this.nativeTableAllLoading = true;
      this.reserver_so = column.order
        ? column?.order == "ascending"
          ? 0
          : 1
        : "";
      this.order_by_so = column.prop ? column.prop : "";
      await this.dispatchXcodeSoAll(store, {
        project: this.localProject,
        level: this.level_so,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_so_id,
        top: this.top_so,
        search: this.serch_input_so,
        old_date: this.old_so_date,
        old_version: this.old_version_so_base,
        order_by: this.order_by_so,
        reverse: this.reserver_so,
        type: this.type,
        dimension: this.dimension_so_all,
      });
      this.nativeTableSoAll = this.nativeAllSoData.slice(
        (this.page_so - 1) * this.size_so,
        this.page_so * this.size_so
      );
      this.nativeTableAllLoading = false;
    },
    sortFun(attr, rev) {
      if (rev == "-") {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }
      return (a, b) => {
        a = a[attr];
        b = b[attr];

        return this.customSort(a, b, rev);
      };
    },
    customSort(a, b, rev) {
      if (a === undefined || a === "-") {
        return 1;
      } else if (b === undefined || b === "-") {
        return -1;
      } else {
        return (a - b) * rev;
      }
    },
    flame_function_change(flag) {
      if (flag) {
        this.level_flame =
          this.level_flame_list?.length > 0 ? this.level_flame_list[0] : "";
      }

      this.functions_flame = this.level_flame
        ? this.xcodeReportData.func_list[this.scene_flame][
            this.level_flame
          ].join(",")
        : "";
    },
    flame_so_change(flag) {
      if (flag) {
        this.so_level_flame =
          this.level_flame_so_list?.length > 0 ? this.level_flame_so_list[0] : "";
      }

      this.so_flame = this.so_list?.length > 0 ? this.so_list : [];
    },
    
    async memoryBtn() {
      this.flame_size_input = "";
      this.flame_so_input = [];
      this.flame_function_input = "";
      this.page_native = 1;
      this.size_native = 10;
      this.flame_size_stack_input = "";
      this.flame_stack_so_input = [];
      this.flame_stack_function_input = "";
      this.report_loading = true;
      this.moudle_loading = true;
      this.funcLoading = true;
      this.flameLoading = true;
      this.flameLoadingStack = true;
      this.nativeTableAllLoading = true;
      await this.dispatchXcodeReport(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: Number(this.type_query),
        type: this.type,
      });
      this.scene_flame =
        this.scene_flame_list?.length > 0 ? this.scene_flame_list[0] : "";
      this.level_flame =
        this.level_flame_list?.length > 0 ? this.level_flame_list[0] : "";
      this.so_scene_flame =
        this.scene_flame_so_list?.length > 0 ? this.scene_flame_so_list[0] : "";
      this.so_level_flame =
        this.level_flame_so_list?.length > 0 ? this.level_flame_so_list[0] : "";
      this.functions_flame = this.level_flame
        ? this.xcodeReportData.func_list[this.scene_flame][
            this.level_flame
          ].join(",")
        : "";
      this.so_flame = this.so_list?.length > 0 ? this.so_list : [];
      // this.functions_flame_api();
      // this.so_flame_api();
      this.report_loading = false;
      this.nativeHead();
      this.valueTime = [];
      // if(this.localProject===7||this.localProject==34){
      //     this.stack_v2_api()
      //   }
      await this.dispatchXcodeNativeTrend(store, {
        project: this.localProject,
        level: this.level,

        report_type: Number(this.type_query),
        start: "",
        end: "",
        type: this.type,

        scene_name: this.scene_func_id_scene,
      });

      this.resBase64 = [];
      this.edit_show = false;
      this.resBase64 = [];

      this.drawNativeTrend(this.device_id, this.level);
      await this.dispatchXcodeNativeFuncTrend(store, {
        project: this.localProject,
        level: this.level_func,

        report_type: Number(this.type_query),
        scene_name: this.scene_func_id,
        start: "",
        end: "",
        type: this.type,
        dimension: this.dimension_func,
      });
      this.index_func = this.funcTrend.func_list.filter((v, index) => index <= 4);
      this.drawNativeFuncTrend();
      let funcSoTrend = await this.dispatchXcodeSoList(store, {
        project: this.localProject,
        level: this.level_func_so,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_func_id_so,
        report_type: this.type_query,
        type: this.type,
        dimension: this.dimension_so,
      });
      this.funcSoTrend = funcSoTrend.map((item) => {
        return item.replace(/\+/g, "");
      });
      if (this.funcSoTrend.length > 0) {
        this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
        await this.dispatchXcodeSoFuncTrend(store, {
          project: this.localProject,
          level: this.level_func_so,

          report_type: Number(this.type_query),
          scene_name: this.scene_func_id_so,
          start: "",
          end: "",
          so_list: this.index_func_so,
          type: this.type,
          dimension: this.dimension_so,
        });
        this.drawSOFuncTrend();
      }

      this.funcLoading = false;
      await this.dispatchXcodeNativeModule(store, {
        project: this.localProject,
        level: this.level,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_id,
        report_type: this.type_query,
        type: this.type,
        dimension: this.dimension_important,
        option: this.option_important,
      });

      // this.Native_thread_important();
      this.moudle_loading = false;
      this.nativeAllChange();
      this.nativeAllChangeSo();
      await this.dispatchXcodeStack(store, {
        project: this.localProject,
        level: this.flame_so,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.type_query,
        scene_name: this.scene_flame_id,
        size: this.flame_size_input,
        so: this.flame_so_input.join(";"),
        func: this.flame_function_input,
        type: this.type,
        dimension: this.dimension_memory,
        option: this.option_memory,
      });
      if (JSON.stringify(this.perfettoStack) === "{}") {
        this.flameShow = false;
        return;
      } else {
        this.flameShow = true;
        this.flame_check_data = false;
        this.$nextTick(() => {
          this.renderFlame("#chart", this.perfettoStack);
        });
      }
      this.flameLoading = false;
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.date,
          version: this.version,
          old_date: this.old_date,
          old_version_base: this.old_version_base,
          device_id: this.device_id,
          type: this.type_query,
          level: encodeURIComponent(this.level),
          level_trend: encodeURIComponent(this.level_trend),
          level_func: encodeURIComponent(this.level_func),
          level_all: encodeURIComponent(this.level_all),
          scene_id: this.scene_id,
          scene_func_id: this.scene_func_id,
          scene_natvie_id: this.scene_natvie_id,
          typeof: this.type,
          // old_record_id: this.old_record_id,
        },
      });
    },
    async nativeAllChange(ev, getDate) {
      this.nativeTableAllLoading = true;
      this.page = 1;
      this.size = 10;
      this.top = 20;
      this.serch_input = "";
      this.old_date = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_name
      )[0].date;
      this.old_version_base = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_name
      )[0].version;
      await this.dispatchXcodeNativeAll(store, {
        project: this.localProject,
        level: this.level_all,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_natvie_id,
        top: this.top,
        search: this.serch_input,
        old_date: this.old_date,
        old_version: this.old_version_base,
        order_by: this.order_by,
        reverse: this.reserver,
        type: this.type,
        dimension: this.dimension_native,
      });
      this.nativeTableAll = this.nativeAllData.slice(
        (this.page - 1) * this.size,
        this.page * this.size
      );
      this.nativeTableAllLoading = false;
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.date,
          version: this.version,
          old_date: this.old_date,
          old_version_base: this.old_version_base,
          device_id: this.device_id,
          type: this.type_query,
          level: encodeURIComponent(this.level),
          level_trend: encodeURIComponent(this.level_trend),
          level_func: encodeURIComponent(this.level_func),
          level_all: encodeURIComponent(this.level_all),
          scene_id: this.scene_id,
          scene_func_id: this.scene_func_id,
          scene_natvie_id: this.scene_natvie_id,
          typeof: this.type,
          // old_record_id: this.old_record_id,
        },
      });

      if (getDate) this.getAllDateOptions()
    },
    
    async nativeAllChangeSo(ev, getDate) {
      this.nativeTableAllLoading = true;
      this.page_so = 1;
      this.size_so = 10;
      this.top_so = 20;
      this.serch_input_so = "";
      this.old_so_date = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].date;
      this.old_version_so_base = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].version;
      await this.dispatchXcodeSoAll(store, {
        project: this.localProject,
        level: this.level_so,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        scene_name: this.scene_so_id,
        top: this.top_so,
        search: this.serch_input_so,
        old_date: this.old_so_date,
        old_version: this.old_version_so_base,
        order_by: "unreleasedSizeDiff",
        reverse: 1,
        type: this.type,
        dimension: this.dimension_so_all,
      });
      this.nativeTableSoAll = this.nativeAllSoData.slice(
        (this.page_so - 1) * this.size_so,
        this.page_so * this.size_so
      );
      this.nativeTableAllLoading = false;
      // this.$router.push({
      //   query: {
      //     ...this.$route.query,
      //     date: this.date,
      //     version: this.version,
      //     old_date: this.old_date,
      //     old_version_base: this.old_version_base,
      //     device_id: this.device_id,
      //     type: this.type_query,
      //     level: this.level,
      //     level_trend: this.level_trend,
      //     level_func: this.level_func,
      //     level_all: this.level_all,
      //     scene_id: this.scene_id,
      //     scene_func_id: this.scene_func_id,
      //     scene_natvie_id: this.scene_natvie_id,
      //     // old_record_id: this.old_record_id,
      //   },
      // });

      if (getDate) this.getLibDateOptions()
    },
    async onSearch(item) {
      this.nativeTableAllLoading = true;
      if (item) {
        this.page = 1;
        this.size = 10;
        await this.dispatchXcodeNativeAll(store, {
          project: this.localProject,
          level: this.level_all,
          device_id: this.device_id,
          date: this.date,
          version: this.version,
          scene_name: this.scene_natvie_id,
          top: this.top,
          search: this.serch_input,
          old_date: this.old_date,
          old_version: this.old_version_base,
          order_by: this.order_by,
          reverse: this.reserver,
          type: this.type,
          dimension: this.dimension_native,
        });
      }

      this.nativeTableAll = this.nativeAllData.slice(
        (this.page - 1) * this.size,
        this.page * this.size
      );
      this.nativeTableAllLoading = false;
    },
    async onSearchSo(item) {
      this.nativeTableAllLoading = true;

      if (item) {
        this.page_so = 1;
        this.size_so = 10;
        await this.dispatchXcodeSoAll(store, {
          project: this.localProject,
          level: this.level_so,
          device_id: this.device_id,
          date: this.date,
          version: this.version,
          scene_name: this.scene_so_id,
          top: this.top_so,
          search: this.serch_input_so,
          old_date: this.old_so_date,
          old_version: this.old_version_so_base,
          order_by: this.order_by_so,
          reverse: this.reserver_so,
          type: this.type,
          dimension: this.dimension_so_all,
        });
      }

      this.nativeTableSoAll = this.nativeAllSoData.slice(
        (this.page_so - 1) * this.size_so,
        this.page_so * this.size_so
      );
      this.nativeTableAllLoading = false;
    },
    addXcodeValueField(data) {
      if (data) {
        if (data?.Name == "root") {
          data.value = data?.MallocSize;
          data.name =
            data?.Name + " " + (data?.MallocSize / 1024).toFixed(2) + "MB";
        } else {
          data.value = data?.MallocSize;
          data.name = data?.Name;
        }

        if (Array.isArray(data.children)) {
          data.children.forEach((child) => {
            this.addXcodeValueField(child);
          });
        }
      }
    },
    traverse_update_node(node) {
      if (!node.children || node.children.length === 0) {
        return { Count: node.Count, MallocSize: node.MallocSize };
      } else {
        let Count_total = 0;
        let MallocSize_total = 0;
        for (let child of node.children) {
          let {
            Count: child_Count,
            MallocSize: child_Malloc,
          } = this.traverse_update_node(child);
          Count_total += child_Count;
          MallocSize_total += child_Malloc;
        }
        node.Count = Count_total;
        node.MallocSize = MallocSize_total;

        return { Count: Count_total, MallocSize: MallocSize_total };
      }
    },
    
    labelWallTime(d, originalColor, colorMapper) {
      // 使用 colorMapper 计算颜色
      const color = colorMapper(d.data.value);

      // 如果没有输入，直接返回计算出的颜色
      if (this.flame_function_input === "" && this.flame_so_input.length == 0) {
        return color;
      } else {
        // 如果输入存在，根据输入内容判断是否需要修改颜色
        if (this.flame_function_input) {
          let list = [this.flame_function_input];
          // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
          const hasMatchingKeyword = list.some((v) => {
            return d.data.Name.toUpperCase().indexOf(v.toUpperCase()) !== -1;
          });

          // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
          return hasMatchingKeyword ? "#f00" : color;
        }
        if (this.flame_so_input.length > 0) {
          const hasMatchingKeyword = this.flame_so_input.some((v) => {
            return (
              d.data.LibraryName.toUpperCase().indexOf(v.toUpperCase()) !== -1
            );
          });

          // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
          return hasMatchingKeyword ? "#f00" : color;
        }
      }
    },
    
    labelWallTime_functions(d, originalColor, colorMapper) {
      // 使用 colorMapper 计算颜色
      const color = colorMapper(d.data.value);

      // 如果没有输入，直接返回计算出的颜色
      if (this.functions_flame === "") {
        return color;
      } else {
        // 如果输入存在，根据输入内容判断是否需要修改颜色
        if (this.functions_flame) {
          let list = this.functions_flame.split(",");
          // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
          const hasMatchingKeyword = list.some((v) => {
            return (
              d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1
            );
          });

          // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
          return hasMatchingKeyword ? "#f00" : color;
        }
      }
    },
    labelWallTime_so(d, originalColor, colorMapper) {
      // 使用 colorMapper 计算颜色
      const color = colorMapper(d.data.value);

      // 如果没有输入，直接返回计算出的颜色

      if (this.so_flame.length === 0) {
        return color;
      } else {
        // 如果输入存在，根据输入内容判断是否需要修改颜色

        let list = this.so_flame;
        // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
        const hasMatchingKeyword = list.some((v) => {
          return d.data.soName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
    },
    
    labelTime (d, data) {
      //  "(" +
      //   (d.parent == null
      //     ? "100%"
      //     : ((d.value / (data as any).value) * 100).toFixed(2) +
      //       "%") +

      //   ")"
      // return `<div><div style="font-size:14px">${d.data.name}</div><div>${d.data.value}</div><div>soName:${d.data.soName}</div></div>`
      // console.log(d)
      return (
        d.data.name +
        "\nsoName:" +
        d.data.soName +
        "\nself:" +
        this.getNum(d.data.value) +
        (d.data.self_diff ? this.diffNum(d.data.self_diff) : "") +
        "\ntotal:" +
        this.getNum(d.data.total) +
        (d.data.self_diff ? this.diffNum(d.data.total_diff) : "")
      );
    },
    labelTimeXcode(d, data) {
      //  "(" +
      //   (d.parent == null
      //     ? "100%"
      //     : ((d.value / (data as any).value) * 100).toFixed(2) +
      //       "%") +

      //   ")"
      // return `<div><div style="font-size:14px">${d.data.name}</div><div>${d.data.value}</div><div>soName:${d.data.soName}</div></div>`
      // console.log(d)
      return (
        d.data.name +
        "\nLibraryName:" +
        d.data.LibraryName +
        "\nMallocSize:" +
        this.sizeCompany(d.data.value) +
        "\nCount:" +
        d.data.Count +
        "\nTotalMallocSize:" +
        this.sizeCompany(d.data.TotalMallocSize)
      );
    },
    renderFlame(selector, data) {
      let flame = flamegraph();
      function getAllValues(node) {
        const values = [node.value];
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => {
            values.push(...getAllValues(child));
          });
        }
        return values;
      }

      // 获取火焰图数据中的最大值
      const allValues = getAllValues(data);
      const maxDataValue = d3.max(allValues);

      // 创建颜色映射器
      const colorMapper = d3
        .scaleLinear()
        .domain([0, maxDataValue * 0.5, maxDataValue])
        .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
      flame
        .width(1200)
        .label((d) => this.labelTimeXcode(d, data))
        // .tooltip({ show: this.customTooltip })
        .transitionDuration(1000)
        // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
        .setColorMapper((d, originalColor) =>
          this.labelWallTime(d, originalColor, colorMapper)
        ) // 传递 colorMapper 参数
        .inverted(true);
      // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

      // .inverted(true);

      // flame.onHover((node) => {
      //   this.func_name = node.data.name;
      //   this.func_rate = node.data.rate + "%";
      // });

      d3.select(selector).datum(data).call(flame);
      // d3.select(selector).style("background-color", "#333");
    },
    
    renderFlame_functions(selector, data) {
      let flame = flamegraph();
      function getAllValues(node) {
        const values = [node.value];
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => {
            values.push(...getAllValues(child));
          });
        }
        return values;
      }

      // 获取火焰图数据中的最大值
      const allValues = getAllValues(data);
      const maxDataValue = d3.max(allValues);

      // 创建颜色映射器
      const colorMapper = d3
        .scaleLinear()
        .domain([0, maxDataValue * 0.5, maxDataValue])
        .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
      flame
        .width(1200)
        .label((d) => this.labelTime(d, data))
        // .tooltip({ show: this.customTooltip })
        .transitionDuration(1000)
        // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
        .setColorMapper((d, originalColor) =>
          this.labelWallTime_functions(d, originalColor, colorMapper)
        ) // 传递 colorMapper 参数
        .inverted(true);
      // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

      // .inverted(true);

      // flame.onHover((node) => {
      //   this.func_name = node.data.name;
      //   this.func_rate = node.data.rate + "%";
      // });

      d3.select(selector).datum(data).call(flame);
      // d3.select(selector).style("background-color", "#333");
    },
    renderFlame_so(selector, data) {
      let flame = flamegraph();
      function getAllValues(node) {
        const values = [node.value];
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => {
            values.push(...getAllValues(child));
          });
        }
        return values;
      }

      // 获取火焰图数据中的最大值
      const allValues = getAllValues(data);
      const maxDataValue = d3.max(allValues);

      // 创建颜色映射器
      const colorMapper = d3
        .scaleLinear()
        .domain([0, maxDataValue * 0.5, maxDataValue])
        .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
      flame
        .width(1200)
        .label((d) => this.labelTime(d, data))
        // .tooltip({ show: this.customTooltip })
        .transitionDuration(1000)
        // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
        .setColorMapper((d, originalColor) =>
          this.labelWallTime_so(d, originalColor, colorMapper)
        ) // 传递 colorMapper 参数
        .inverted(true);
      // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

      // .inverted(true);

      // flame.onHover((node) => {
      //   this.func_name = node.data.name;
      //   this.func_rate = node.data.rate + "%";
      // });

      d3.select(selector).datum(data).call(flame);
      // d3.select(selector).style("background-color", "#333");
    },

    customTooltip(d) {
      // 在这里自定义你的 tooltip 内容
      // d 是当前 hover 的数据点
      // 返回一个 HTML 字符串，将作为 tooltip 的内容
      return `<div>
        <strong>Label:</strong> ${d.data.name}<br>
        <strong>Value:</strong> ${d.data.value}
        </div>`;
    },
    handleHover(node, el) {
      const targetElement = d3.selectAll(`g[name='${node.data.name}']`);

      if (node) {
        // 当悬停在方块上时，为目标元素添加 .hovered 类
        targetElement.classed("hovered", true);
      } else {
        // 当悬停离开方块时，删除 .hovered 类
        targetElement.classed("hovered", false);
      }
    },
    getNum(num) {
      if (num >= 1024 * 1024) {
        return (num / 1024 / 1024).toFixed(2) + "MB";
      } else if (num >= 1024 && num < 1024 * 1024) {
        return (num / 1024).toFixed(2) + "KB";
      } else if (num < 1024) {
        return num.toFixed(2) + "B";
      }
    },
    sizeCompany(item) {
      if (String(item) != "") {
        if (Number(item) < 1024) {
          return String(item) + "K";
        }
        if (Number(item) > 1024) {
          return (Number(item) / 1024).toFixed(1) + "M";
        }
      } else {
        return "";
      }
    },
    diffNum(num) {
      let diff = Math.abs(num);
      let data = this.getNum(diff);
      if (num < 0) {
        return "(-" + data + ")";
      } else {
        return "(+" + data + ")";
      }
    },
  },
    
  async mounted() {
    this.flameLoadingStack = true;
    this.report_loading = true;
    this.moudle_loading = true;
    this.funcLoading = true;
    this.nativeTableAllLoading = true;
    this.flameLoading = true;
    this.type = this.$route.query.typeof ? this.$route.query.typeof : "";
    await this.dispatchXcodeTypeOptions(store, {
      project: this.localProject,
      type: this.type,
    });
    this.type_query = this.$route.query.type
      ? Number(this.$route.query.type)
      : this.perfTypeOptions[0].report_type;
    await this.dispatchXcodeDateOptions(store, {
      project: this.localProject,
      report_type: this.type_query,
      type: this.type
    });
    await this.dispatchPerfettoSettings(store, {
      project: this.localProject,
    });

    this.base_id = this.settings.xcode_set?.name
      ? this.settings.xcode_set?.name
      : "";

    // this.task_id = this.$route.query.task_record_id
    //   ? Number(this.$route.query.task_record_id)
    //   : this.perfDateOptions[0].task_record_id;
    this.date = this.$route.query.date
      ? this.$route.query.date
      : this.perfDateOptions[0].date;
    this.version = this.$route.query.version
      ? this.$route.query.version
      : this.perfDateOptions[0].version;
    this.date_name = this.perfDateOptions.filter(
      (v) => v.date == this.date && v.version == this.version
    )[0].name;

    if (this.$route.query.old_date) {
      this.old_date = this.$route.query.old_date;
    }
    if (this.$route.query.old_version_base) {
      this.old_version_base = this.$route.query.old_version_base;
    }
    if (this.$route.query.old_date && this.$route.query.old_version_base) {
      // this.old_date_name = this.perfDateOptions.filter(
      //   (v) => v.date == this.old_date && v.version == this.old_version_base
      // )[0].name;
      this.old_date_so_name = this.perfDateOptions.filter(
        (v) => v.date == this.old_date && v.version == this.old_version_base
      )[0].name;
      this.old_stack_name = this.perfDateOptions.filter(
        (v) => v.date == this.old_date && v.version == this.old_version_base
      )[0].name;
      this.old_so_date = this.perfDateOptions.filter(
        (v) => v.date == this.old_date && v.version == this.old_version_base
      )[0].date;
      this.old_version_so_base = this.perfDateOptions.filter(
        (v) => v.date == this.old_date && v.version == this.old_version_base
      )[0].version;
    } else {
      this.old_record_id_created();
      this.old_date = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_name
      )[0].date;

      this.old_date_stack = this.perfDateOptions.filter(
        (v) => v.name == this.old_stack_name
      )[0].date;
      this.old_version_base = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_name
      )[0].version;
      this.old_so_date = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].date;
      this.old_version_so_base = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].version;
      this.old_version_stack = this.perfDateOptions.filter(
        (v) => v.name == this.old_stack_name
      )[0].version;
    }
    // else {
    //   this.old_record_id_created();
    // }
    await this.dispatchXcodeDeviceOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,

      report_type: this.type_query,
      type: this.type,
    });
    
    const option = this.perfDeviceOptions.find(item => item.name.includes('J200')) || this.perfDeviceOptions[0]
    this.device_id = this.$route.query.device_id
      ? this.$route.query.device_id
      : option?.device_id;

    await this.dispatchXcodeDimensOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,

      report_type: this.type_query,
      type: this.type,
      device_id: this.device_id,
    });
    this.dimension_scene = this.dimensionsList[0].type;
    this.dimension_so = this.dimensionsList[0].type;
    this.dimension_func = this.dimensionsList[0].type;
    this.dimension_native = this.dimensionsList[0].type;
    this.dimension_important = this.dimensionsList[0].type;
    this.dimension_so_all = this.dimensionsList[0].type;
    this.dimension_memory = this.dimensionsList[0].type;
    await this.dispatchXcodeReport(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: Number(this.type_query),
      type: this.type,
    });
    this.scene_flame =
      this.scene_flame_list?.length > 0 ? this.scene_flame_list[0] : "";
    this.level_flame =
      this.level_flame_list?.length > 0 ? this.level_flame_list[0] : "";
    this.so_scene_flame =
      this.scene_flame_so_list?.length > 0 ? this.scene_flame_so_list[0] : "";
    this.so_level_flame =
      this.level_flame_so_list?.length > 0 ? this.level_flame_so_list[0] : "";
    this.functions_flame = this.level_flame
      ? this.xcodeReportData.func_list[this.scene_flame][
          this.level_flame
        ].join(",")
      : "";
    this.so_flame = this.so_list?.length > 0 ? this.so_list : [];
    // this.functions_flame_api();
    // this.so_flame_api();
    this.report_loading = false;
    this.nativeHead();
    await this.dispatchXcodeLevelOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,

      report_type: this.type_query,
      type: this.type,
      device_id: this.device_id,
    });

    this.level = this.$route.query.level
      ? decodeURIComponent(this.$route.query.level)
      : this.perfLeveOptions[0].level;
    this.level_trend = this.$route.query.level_trend
      ? decodeURIComponent(this.$route.query.level_trend)
      : this.perfLeveOptions[0].level;
    this.level_func = this.$route.query.level_func
      ? decodeURIComponent(this.$route.query.level_func)
      : this.perfLeveOptions[0].level;
    this.level_func_so = this.$route.query.level_func
      ? decodeURIComponent(this.$route.query.level_func)
      : this.perfLeveOptions[0].level;
    this.level_all = this.$route.query.level_all
      ? decodeURIComponent(this.$route.query.level_all)
      : this.perfLeveOptions[0].level;
    this.level_stack = this.$route.query.level_all
      ? decodeURIComponent(this.$route.query.level_all)
      : this.perfLeveOptions[0].level;
    this.level_so = this.$route.query.level_all
      ? decodeURIComponent(this.$route.query.level_all)
      : this.perfLeveOptions[0].level;
    this.flame_so = this.$route.query.level_all
      ? decodeURIComponent(this.$route.query.level_all)
      : this.perfLeveOptions[0].level;

    await this.dispatchXcodeSceneOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,

      report_type: this.type_query,
      type: this.type,
      device_id: this.device_id,
    });

    this.scene_id = this.$route.query.scene_id
      ? this.$route.query.scene_id
      : this.loading_created();
    this.scene_func_id = this.$route.query.scene_func_id
      ? this.$route.query.scene_func_id
      : this.loading_created();
    this.scene_func_id_so = this.$route.query.scene_func_id
      ? this.$route.query.scene_func_id
      : this.loading_created();
    this.scene_func_id_scene = this.$route.query.scene_func_id
      ? this.$route.query.scene_func_id
      : this.loading_created();
    this.scene_natvie_id = this.$route.query.scene_natvie_id
      ? this.$route.query.scene_natvie_id
      : this.loading_created();
    this.scene_stack_id = this.$route.query.scene_natvie_id
      ? this.$route.query.scene_natvie_id
      : this.loading_created();
    this.scene_so_id = this.$route.query.scene_natvie_id
      ? this.$route.query.scene_natvie_id
      : this.loading_created();
    this.scene_flame_id = this.$route.query.scene_natvie_id
      ? this.$route.query.scene_natvie_id
      : this.loading_created();
    if(this.localProject===7){
      this.stack_v2_api()
    }
    
    this.getAllDateOptions()
    this.getLibDateOptions()

    await this.dispatchXcodeNativeTrend(store, {
      project: this.localProject,
      level: this.level,

      report_type: Number(this.type_query),
      start: "",
      end: "",
      type: this.type,

      scene_name: this.scene_func_id_scene,
    });
    this.resBase64 = [];

    this.drawNativeTrend(this.device_id, this.level);
    await this.dispatchXcodeNativeFuncTrend(store, {
      project: this.localProject,
      level: this.level_func,

      report_type: Number(this.type_query),
      scene_name: this.scene_func_id,
      start: "",
      end: "",
      type: this.type,
      dimension: this.dimension_func,
    });
    this.index_func = this.funcTrend.func_list.filter((v, index) => index <= 4);
    this.drawNativeFuncTrend();
    this.funcLoading = false;
    let funcSoTrend = await this.dispatchXcodeSoList(store, {
      project: this.localProject,
      level: this.level_func_so,
      device_id: this.device_id,
      date: this.date,
      version: this.version,
      scene_name: this.scene_func_id_so,
      report_type: this.type_query,
      type: this.type,
      dimension: this.dimension_so,
    });
    this.funcSoTrend = funcSoTrend.map((item) => {
      return item.replace(/\+/g, "");
    });
    if (this.funcSoTrend.length > 0) {
      this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
      await this.dispatchXcodeSoFuncTrend(store, {
        project: this.localProject,
        level: this.level_func_so,

        report_type: Number(this.type_query),
        scene_name: this.scene_func_id_so,
        start: "",
        end: "",
        so_list: this.index_func_so,
        type: this.type,
        dimension: this.dimension_so,
      });
      this.drawSOFuncTrend();
    }

    this.drawSOFuncTrend();
    await this.dispatchXcodeNativeModule(store, {
      project: this.localProject,
      level: this.level,
      device_id: this.device_id,
      date: this.date,
      version: this.version,
      scene_name: this.scene_id,
      report_type: this.type_query,
      type: this.type,
      dimension: this.dimension_important,
      option: this.option_important,
    });

    // this.Native_thread_important();
    this.moudle_loading = false;
    
    const dateAndVersion = this.libDateOptions.find(item => item.name == this.old_date_so_name)
    await this.dispatchXcodeNativeAll(store, {
      project: this.localProject,
      level: this.level_all,
      device_id: this.device_id,
      date: this.date,
      version: this.version,
      scene_name: this.scene_natvie_id,
      top: this.top,
      search: this.serch_input,
      old_date: dateAndVersion.date,
      old_version: dateAndVersion.version,
      order_by: "",
      reverse: "",
      type: this.type,
      dimension: this.dimension_so_all,
    });
    await this.dispatchXcodeSoAll(store, {
      project: this.localProject,
      level: this.level_so,
      device_id: this.device_id,
      date: this.date,
      version: this.version,
      scene_name: this.scene_so_id,
      top: this.top_so,
      search: this.serch_input_so,
      old_date: this.old_so_date,
      old_version: this.old_version_so_base,
      order_by: "unreleasedSizeDiff",
      reverse: 1,
      type: this.type,
      dimension: this.dimension_so_all,
    });
    this.nativeTableAll = this.nativeAllData.slice(
      (this.page - 1) * this.size,
      this.page * this.size
    );
    this.nativeTableSoAll = this.nativeAllSoData.slice(
      (this.page_so - 1) * this.size_so,
      this.page_so * this.size_so
    );
    this.nativeTableAllLoading = false;
    await this.dispatchXcodeStack(store, {
      project: this.localProject,
      level: this.flame_so,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      scene_name: this.scene_flame_id,
      size: this.flame_size_input,
      so: this.flame_so_input.join(";"),
      func: this.flame_function_input,
      type: this.type,
      dimension: this.dimension_memory,
      option: this.option_memory,
    });
    if (JSON.stringify(this.perfettoStack) === "{}") {
      this.flameShow = false;
      return;
    } else {
      this.flameShow = true;
      this.flame_check_data = false;
      this.$nextTick(() => {
        this.renderFlame("#chart", this.perfettoStack);
      });
    }

    this.flameLoading = false;

    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.date,
        version: this.version,
        old_date: this.old_date,
        old_version_base: this.old_version_base,
        device_id: this.device_id,
        type: this.type_query,
        level: encodeURIComponent(this.level),
        level_trend: encodeURIComponent(this.level_trend),
        level_func: encodeURIComponent(this.level_func),
        level_all: encodeURIComponent(this.level_all),
        scene_id: this.scene_id,
        scene_func_id: this.scene_func_id,
        scene_natvie_id: this.scene_natvie_id,
        typeof: this.type,
        // old_record_id: this.old_record_id,
      },
    });
  }
}
</script>


<style scoped>
.link-like {
  display: inline; /* 使得段落元素行内显示 */
  color: #61c3e4; /* 设置链接文字颜色 */
  text-decoration: none; /* 添加下划线 */
  cursor: pointer; /* 鼠标悬停时显示手型光标 */
}

.download-link {
  color: #61c3e4; /* 设置链接颜色为蓝色 */
  text-decoration: underline; /* 添加下划线 */
  cursor: pointer; /* 设置鼠标悬停时的指针样式为手指 */
}
a {
  color: #61c3e4;
}
.img_border {
  padding: 4px;
  border-radius: 4px;
}
.frames-info {
  font-size: 14px;
  font-weight: bold;
}

.frames-num {
  color: #3a84ff;
}
.gallery__big {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(9, 11, 24, 0.9);
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.gallery__big_box {
  position: absolute;
  top: 11.1%;
  bottom: 23.1%;
  left: 8.3%;
  right: 8.3%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gallery__big_wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.text_blue {
  color: rgb(93, 153, 213);
  font-weight: bold;
}
.Ecard {
  width: 1260px;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0 2px 10px rgb(179 186 220 / 40%);
  font-size: 15px;
}
.Ecard .testMain {
  padding: 30px;
}
.Ecard .banner {
  width: 100%;
}
/* 版本 */
.versionGeneration2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.versionGeneration p {
  margin-top: 10px !important;
  line-height: 32px;
}
.versionGeneration .copyVal {
  display: flex;
  justify-content: end;
}
.mainContent {
  width: 97%;
  margin: 0 auto;
}
/* 核心指标风险详情表格 */
.gameTable {
  width: 100%;
  background-color: #f5f7fa;
  border: 1px solid #e2e7eb;
  border-collapse: collapse;
  font-size: 13px;
}
.gameTable .gameIcon {
  width: 93px;
  text-align: center;
}
.gameTable .gameIcon img {
  width: 95%;
}
.gameTable span {
  font-weight: normal;
  /* font-size:14px; */
}
.gameTable td {
  border: 1px solid #e2e7eb;
  height: 31px;
  white-space: nowrap;
  font-weight: bold;
}
.gameTable tr:nth-of-type(n + 2) td {
  text-indent: 8px;
}

.gameTable .game_name,
.gameTable .com_risk_green,
.gameTable .com_risk_red {
  font-weight: bold;
}
.gameTable .com_risk_red {
  color: red;
}
.gameTable .com_risk_green {
  color: #00b050;
}
/* 核心指标风险结论 */
.conclusion div {
  margin-left: 11px;
  color: #303133;
}
.conclusion ul {
  padding: 0;
  list-style-type: none;
  margin: 5px 0;
}
.conclusion p {
  font-weight: 550;
  font-size: 15px;
}

/* FPS趋势图 */
.FPStrend {
  margin-bottom: 20px;
  /*height: 350px;*/
}
.FPStrend .labelStyle {
  text-align: left;
  margin-bottom: 5px;
  font-weight: 550;
}

/* 详细测试数据 */
.detailedTest .describe {
  font-size: 15px;
}
.detailedTest .describe span {
  background-color: #e7e6e6;
}
.detailedTestTable #Table_Right_div {
  overflow-x: auto;
  width: 928px;
}
.outerLayerTable .Table_Left td,
.outerLayerTable .Table_Right_in td {
  height: 31px;
  border-collapse: collapse;
  font-size: 12px;
  white-space: nowrap;
  text-align: center;
  border-bottom: 1px solid #e2e7eb;
  border-right: 1px solid #e2e7eb;
  padding: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.outerLayerTable .Table_Left {
  width: 237px;
  max-width: 320px;
}

.outerLayerTable .Table_Left,
.outerLayerTable .Table_Right_in tr:nth-child(-n + 2) {
  background-color: #5d99d5;
  color: white;
  font-weight: bold;
}
.outerLayerTable2 .Table_Left,
.outerLayerTable2 .Table_Right_in tr:nth-child(-n + 2) {
  background-color: #5957b1 !important;
}
.outerLayerTable2 .Table_Right_in tr:nth-child(n + 3) td:nth-child(2) {
  background-color: #cccccc;
}
.outerLayerTable2 .Table_Right_in tr:nth-child(n + 3) td:first-child {
  background-color: #ffffff !important;
  color: #4659b8;
}
.Table_Right_in tr:nth-child(n + 3) td:first-child {
  background-color: #cccccc;
}
.outerLayerTable .Table_Right_in {
  table-layout: fixed;
}
.outerLayerTable .Table_Left table {
  width: 100%;
}
.outerLayerTable .scrollTD {
  display: none;
}

.outerLayerTable .scrollTD2 {
  height: 18px !important;
}

/* 底部 */
.footer {
  background-color: #eff4fa;
  width: 100%;
  height: 31px;
  text-align: center;
}
</style>


<style>
/* 核心指标风险详情 */
/* .banner_btn .el-dialog{
  height:90% !important
} */
.config_class .el-dialog {
  padding: 30px;
}
.banner_btn .el-dialog__body {
  overflow-y: auto;
  height: 800px !important;
}
.banner_btn .el-dialog__footer {
  height: 70px !important;
}
.corePerformance_in .el-table thead {
  color: #303133;
}
.corePerformance_in .el-table td,
.corePerformance_in .el-table th {
  height: 31px;
  padding: 0;
}
.corePerformance_in .el-table {
  margin-bottom: 20px;
  font-size: 13px;
}
.versionGeneration .iTemWidth .el-form-item__content {
  width: 150px !important;
}
.versionGeneration .iTemWidth2 .el-form-item__content {
  min-width: 50px !important;
}
/* 核心性能指标趋势 */
.Core_performance .el-card {
  height: 340px;
}
.Core_performance .trend_bottom {
  display: flex;
  justify-content: space-between;
}
.Core_performance .trend_bottom .el-card {
  width: 49.1%;
}
.queryReport .el-form-item__content {
  margin-right: 10px;
}
.editRecipient .el-form-item {
  margin-bottom: 15px !important;
}

.queryReport .el-select--mini {
  width: 546px !important;
}

/* .el-input {
  width: 300px;
} */
/* 注释，因为会影响其他页面, 如需使用，请添加前置class or id */
/* .el-button el-button--info el-button--mini {
  margin-left: 10px;
} */
.report-input {
  width: 300px !important;
}
/* .el-form-item__label {
  line-height: 40px !important;
} */
.editBtn {
  margin-right: 10px;
}
.gameTable1 {
  width: 100%;
  font-size: 13px;
}
.gameTable1 td {
  border: 1px solid #e2e7eb;
  height: 31px;
  white-space: nowrap;
  text-align: center;
}
.ql-editor {
  min-height: 100px !important; /* 您可以根据需要设置所需的高度 */
}
.custom-table_top th {
  text-align: center;
}
.input_none .el-select__tags > span {
  display: none;
}
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(1px); /* 虚化效果 */
  z-index: 100; /* 将遮罩层置于页面内容之上 */
}
.centered-message.el-message {
  position: fixed !important;
  top: 35% !important;
  left: 55% !important;
  transform: translate(-50%, -50%);
  font-size: 2.5rem; /* 调整字体大小 */
  padding: 1rem 2.5rem; /* 调整内边距 */
}
.native_table .el-table .descending .sort-caret.descending {
  border-top-color: #fff !important;
}
.native_table .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #fff !important;
}
.native_input_class .el-input--mini .el-input__inner {
  width: 133px !important;
}
.d3-flame-graph .fade {
  opacity: 0.6 !important;
}

.d3-flame-graph .title {
  font-size: 20px;
  font-family: Verdana;
}

.d3-flame-graph-tip {
  background-color: black;
  border: none;
  border-radius: 3px;
  padding: 5px 10px 5px 10px;
  min-width: 250px;
  text-align: left;
  color: white;
  z-index: 10;
}
.d3-flame-graph rect {
  stroke: #eeeeee;
  fill-opacity: 0.8;
}

.d3-flame-graph rect:hover {
  stroke: #474747;
  stroke-width: 0.5;
  cursor: pointer;
}

.d3-flame-graph-label {
  pointer-events: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  font-family: Verdana;
  margin-left: 4px;
  margin-right: 4px;
  line-height: 1.5;
  padding: 0 0 0;
  font-weight: 400;
  color: black;
  text-align: left;
}
.hovered rect {
  stroke: black !important;
  stroke-width: 2px !important;
}

.hovered text {
  font-weight: bold !important;
}

.spacName {
  margin: 20px 0 40px 0;
}

.TitleStyle {
  font-size: 17.5px;
}

.TitleStyle span {
  width: 6px;
  height: 15px;
  background-color: #2b64bb;
  margin-right: 5px;
  display: inline-block;
}

.subTitle {
  color: #2b64bb;
  font-size: 22px;
  vertical-align: inherit;
}

h6 {
  font-size: 14px;
}

.editRecipient {
    padding: 25px;
    background-color: #f8f9fa;
}
</style>
